export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `DateTime` scalar type represents a date and time. `DateTime` expects timestamps to be formatted in accordance with the [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) standard. */
  DateTime: any;
  Guid: any;
  Long: any;
  /** The `Seconds` scalar type represents a period of time represented as the total number of seconds in range [-922337203685, 922337203685]. */
  Seconds: any;
};

export type AdvertisementMutations = {
  __typename?: 'AdvertisementMutations';
  updateAdvertisementCommand?: Maybe<Response_AdvertisementUpdateDto>;
};


export type AdvertisementMutationsUpdateAdvertisementCommandArgs = {
  request?: InputMaybe<InputMutationData_AdvertisementUpdateDto>;
};

export type AdvertisementQueries = {
  __typename?: 'AdvertisementQueries';
  getAdvertisementQuery?: Maybe<Response_AdvertisementDto>;
  homeAdvertisementsQuery?: Maybe<Response_HomeAdvertisementDto>;
};


export type AdvertisementQueriesGetAdvertisementQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_AdvertisementDto>;
};


export type AdvertisementQueriesHomeAdvertisementsQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_HomeAdvertisementDto>;
};

export enum AdvertisementType {
  MobileViewUnderPrograms = 'MOBILE_VIEW_UNDER_PROGRAMS',
  Simple = 'SIMPLE',
  WebHeader = 'WEB_HEADER',
  WebUnderPrograms = 'WEB_UNDER_PROGRAMS'
}

export type ArchiveMutations = {
  __typename?: 'ArchiveMutations';
  deleteArchiveCommand?: Maybe<Response_ArchiveDeleteDto>;
  updateArchiveCommand?: Maybe<Response_ArchiveUpdateDto>;
  updateArchiveViewCommand?: Maybe<Response_ArchiveViewCountUpdateDto>;
  updateHeyatArchiveCommand?: Maybe<Response_ArchiveUpdateDto>;
};


export type ArchiveMutationsDeleteArchiveCommandArgs = {
  request?: InputMaybe<InputMutationData_ArchiveDeleteDto>;
};


export type ArchiveMutationsUpdateArchiveCommandArgs = {
  request?: InputMaybe<InputMutationData_ArchiveUpdateDto>;
};


export type ArchiveMutationsUpdateArchiveViewCommandArgs = {
  request?: InputMaybe<InputMutationData_ArchiveViewCountUpdateDto>;
};


export type ArchiveMutationsUpdateHeyatArchiveCommandArgs = {
  request?: InputMaybe<InputMutationData_ArchiveUpdateDto>;
};

export type ArchiveQueries = {
  __typename?: 'ArchiveQueries';
  archives?: Maybe<Response_ArchiveReadDto>;
  heyatArchives?: Maybe<Response_ArchiveReadDto>;
};


export type ArchiveQueriesArchivesArgs = {
  filter?: InputMaybe<InputQueryFilter_ArchiveReadDto>;
};


export type ArchiveQueriesHeyatArchivesArgs = {
  filter?: InputMaybe<InputQueryFilter_ArchiveReadDto>;
};

export type BlogContentCategoryMutations = {
  __typename?: 'BlogContentCategoryMutations';
  createBlogContentCategory?: Maybe<Response_BlogContentCategoryCreateDto>;
  deleteBlogContentCategoryCommand?: Maybe<Response_BlogContentCategoryDeleteDto>;
  updateBlogContentCategoryCommand?: Maybe<Response_BlogContentCategoryUpdateDto>;
};


export type BlogContentCategoryMutationsCreateBlogContentCategoryArgs = {
  request?: InputMaybe<InputMutationData_BlogContentCategoryCreateDto>;
};


export type BlogContentCategoryMutationsDeleteBlogContentCategoryCommandArgs = {
  request?: InputMaybe<InputMutationData_BlogContentCategoryDeleteDto>;
};


export type BlogContentCategoryMutationsUpdateBlogContentCategoryCommandArgs = {
  request?: InputMaybe<InputMutationData_BlogContentCategoryUpdateDto>;
};

export type BlogContentCategoryQueries = {
  __typename?: 'BlogContentCategoryQueries';
  blogContentCategories?: Maybe<Response_BlogContentCategoryQueryDto>;
};


export type BlogContentCategoryQueriesBlogContentCategoriesArgs = {
  filter?: InputMaybe<InputQueryFilter_BlogContentCategoryQueryDto>;
};

export type BlogMutations = {
  __typename?: 'BlogMutations';
  createBlogCommand?: Maybe<Response_BlogCreateDto>;
  deleteBlogCommand?: Maybe<Response_BlogDeleteDto>;
  updateBlogCommand?: Maybe<Response_BlogUpdateDto>;
};


export type BlogMutationsCreateBlogCommandArgs = {
  request?: InputMaybe<InputMutationData_BlogCreateDto>;
};


export type BlogMutationsDeleteBlogCommandArgs = {
  request?: InputMaybe<InputMutationData_BlogDeleteDto>;
};


export type BlogMutationsUpdateBlogCommandArgs = {
  request?: InputMaybe<InputMutationData_BlogUpdateDto>;
};

export type BlogQueries = {
  __typename?: 'BlogQueries';
  blogs?: Maybe<Response_BlogQueryDto>;
};


export type BlogQueriesBlogsArgs = {
  filter?: InputMaybe<InputQueryFilter_BlogQueryDto>;
};

export type ContactMutations = {
  __typename?: 'ContactMutations';
  createContactUsCommand?: Maybe<Response_ContactUsCreateDto>;
  createUnAuthorizedContactUsCommand?: Maybe<Response_ContactUnAuthorizedUsCreateDto>;
  deleteContactUsCommand?: Maybe<Response_ContactUsDeleteDto>;
  updateContactUsCommand?: Maybe<Response_ContactUsUpdateDto>;
};


export type ContactMutationsCreateContactUsCommandArgs = {
  request?: InputMaybe<InputMutationData_ContactUsCreateDto>;
};


export type ContactMutationsCreateUnAuthorizedContactUsCommandArgs = {
  request?: InputMaybe<InputMutationData_ContactUnAuthorizedUsCreateDto>;
};


export type ContactMutationsDeleteContactUsCommandArgs = {
  request?: InputMaybe<InputMutationData_ContactUsDeleteDto>;
};


export type ContactMutationsUpdateContactUsCommandArgs = {
  request?: InputMaybe<InputMutationData_ContactUsUpdateDto>;
};

export type ContactQueries = {
  __typename?: 'ContactQueries';
  getContactUsUnitsQuery?: Maybe<Response_ContactUsUnitDto>;
  getContactsUsQuery?: Maybe<Response_ContactUsReadDto>;
};


export type ContactQueriesGetContactUsUnitsQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_ContactUsUnitDto>;
};


export type ContactQueriesGetContactsUsQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_ContactUsReadDto>;
};

export type DashboardReportQueries = {
  __typename?: 'DashboardReportQueries';
  getHeyatDashboardReportQuery?: Maybe<Response_HeyatDashboardReportDto>;
  getUserDashboardReportQuery?: Maybe<Response_UserDashboardReportDto>;
};


export type DashboardReportQueriesGetHeyatDashboardReportQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_HeyatDashboardReportDto>;
};


export type DashboardReportQueriesGetUserDashboardReportQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_UserDashboardReportDto>;
};

export enum EntityType {
  Advertisement = 'ADVERTISEMENT',
  Blog = 'BLOG',
  Country = 'COUNTRY',
  Haram = 'HARAM',
  Heyat = 'HEYAT',
  HeyatAlbum = 'HEYAT_ALBUM',
  HeyatVideo = 'HEYAT_VIDEO',
  Language = 'LANGUAGE',
  News = 'NEWS',
  Occasion = 'OCCASION',
  Page = 'PAGE',
  Quran = 'QURAN',
  Slider = 'SLIDER',
  SpeakerSinger = 'SPEAKER_SINGER',
  Test = 'TEST',
  Ticket = 'TICKET',
  User = 'USER'
}

export enum ExceptionGraphType {
  Accepted = 'ACCEPTED',
  BadGateway = 'BAD_GATEWAY',
  BadRequest = 'BAD_REQUEST',
  CannotDelete = 'CANNOT_DELETE',
  Conflict = 'CONFLICT',
  Continue = 'CONTINUE',
  Created = 'CREATED',
  EntityExist = 'ENTITY_EXIST',
  ExpectationFailed = 'EXPECTATION_FAILED',
  Forbidden = 'FORBIDDEN',
  GatewayTimeout = 'GATEWAY_TIMEOUT',
  Gone = 'GONE',
  HttpVersionNotSupported = 'HTTP_VERSION_NOT_SUPPORTED',
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  LengthRequired = 'LENGTH_REQUIRED',
  MethodNotAllowed = 'METHOD_NOT_ALLOWED',
  Moved = 'MOVED',
  MultipleChoices = 'MULTIPLE_CHOICES',
  NonAuthoritativeInformation = 'NON_AUTHORITATIVE_INFORMATION',
  NotAcceptable = 'NOT_ACCEPTABLE',
  NotFound = 'NOT_FOUND',
  NotImplemented = 'NOT_IMPLEMENTED',
  NotModified = 'NOT_MODIFIED',
  NoContent = 'NO_CONTENT',
  Ok = 'OK',
  PartialContent = 'PARTIAL_CONTENT',
  PaymentRequired = 'PAYMENT_REQUIRED',
  PreconditionFailed = 'PRECONDITION_FAILED',
  ProxyAuthenticationRequired = 'PROXY_AUTHENTICATION_REQUIRED',
  Redirect = 'REDIRECT',
  RedirectMethod = 'REDIRECT_METHOD',
  RequestedRangeNotSatisfiable = 'REQUESTED_RANGE_NOT_SATISFIABLE',
  RequestEntityTooLarge = 'REQUEST_ENTITY_TOO_LARGE',
  RequestTimeout = 'REQUEST_TIMEOUT',
  RequestUriTooLong = 'REQUEST_URI_TOO_LONG',
  ResetContent = 'RESET_CONTENT',
  ServiceUnavailable = 'SERVICE_UNAVAILABLE',
  SwitchingProtocols = 'SWITCHING_PROTOCOLS',
  TemporaryRedirect = 'TEMPORARY_REDIRECT',
  Unauthorized = 'UNAUTHORIZED',
  UnsupportedMediaType = 'UNSUPPORTED_MEDIA_TYPE',
  Unused = 'UNUSED',
  UpgradeRequired = 'UPGRADE_REQUIRED',
  UseProxy = 'USE_PROXY'
}

export type FaqMutations = {
  __typename?: 'FAQMutations';
  createFAQCommand?: Maybe<Response_FaqDto>;
  deleteFAQCommand?: Maybe<Response_FaqDeleteDto>;
  updateFAQCommand?: Maybe<Response_FaqDto>;
};


export type FaqMutationsCreateFaqCommandArgs = {
  request?: InputMaybe<InputMutationData_FaqDto>;
};


export type FaqMutationsDeleteFaqCommandArgs = {
  request?: InputMaybe<InputMutationData_FaqDeleteDto>;
};


export type FaqMutationsUpdateFaqCommandArgs = {
  request?: InputMaybe<InputMutationData_FaqDto>;
};

export type FaqQueries = {
  __typename?: 'FAQQueries';
  getFAQQuery?: Maybe<Response_FaqReadDto>;
  homeFAQsQuery?: Maybe<Response_HomeFaqDto>;
};


export type FaqQueriesGetFaqQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_FaqReadDto>;
};


export type FaqQueriesHomeFaQsQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_HomeFaqDto>;
};

export type FileMutations = {
  __typename?: 'FileMutations';
  deleteFile?: Maybe<Response_FileDeleteDto>;
  upload?: Maybe<Response_FileResDto>;
  uploadInSignup?: Maybe<Response_FileResDto>;
};


export type FileMutationsDeleteFileArgs = {
  request?: InputMaybe<InputMutationData_FileDeleteDto>;
};


export type FileMutationsUploadArgs = {
  request?: InputMaybe<InputMutationData_FileReqDto>;
};


export type FileMutationsUploadInSignupArgs = {
  request?: InputMaybe<InputMutationData_FileReqDto>;
};

export enum GalleryStatus {
  Confirmed = 'CONFIRMED',
  Pending = 'PENDING',
  Reject = 'REJECT'
}

export type HaramMutations = {
  __typename?: 'HaramMutations';
  createHaramCommand?: Maybe<Response_HaramDto>;
  deleteHaramCommand?: Maybe<Response_HaramDeleteDto>;
  updateHaramCommand?: Maybe<Response_HaramDto>;
};


export type HaramMutationsCreateHaramCommandArgs = {
  request?: InputMaybe<InputMutationData_HaramDto>;
};


export type HaramMutationsDeleteHaramCommandArgs = {
  request?: InputMaybe<InputMutationData_HaramDeleteDto>;
};


export type HaramMutationsUpdateHaramCommandArgs = {
  request?: InputMaybe<InputMutationData_HaramDto>;
};

export type HaramQueries = {
  __typename?: 'HaramQueries';
  getHaramQuery?: Maybe<Response_HaramDto>;
  homeHaramsQuery?: Maybe<Response_HomeHaramDto>;
};


export type HaramQueriesGetHaramQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_HaramDto>;
};


export type HaramQueriesHomeHaramsQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_HomeHaramDto>;
};

export type HeyatMutations = {
  __typename?: 'HeyatMutations';
  changeAlbumStatusCommand?: Maybe<Response_GalleryStatusDto>;
  changeHeyatStatusCommand?: Maybe<Response_HeyatStatusDto>;
  changeVideoStatusCommand?: Maybe<Response_GalleryStatusDto>;
  createHeyatAlbumCommand?: Maybe<Response_HeyatAlbumDto>;
  createHeyatCommand?: Maybe<Response_HeyatCreateResDto>;
  createHeyatVideoCommand?: Maybe<Response_HeyatVideoDto>;
  deleteHeyatAlbumCommand?: Maybe<Response_HeyatAlbumDeleteDto>;
  deleteHeyatCommand?: Maybe<Response_HeyatDeleteDto>;
  deleteHeyatVideoCommand?: Maybe<Response_HeyatVideoDeleteDto>;
  downloadVideoCommand?: Maybe<Response_DownloadVideoDto>;
  generateLiveBroadCastSettingTokenCommand?: Maybe<Response_LiveBroadCastSettingTokenDto>;
  updateHeyatAlbumCommand?: Maybe<Response_HeyatAlbumDto>;
  updateHeyatCommand?: Maybe<Response_HeyatUpdateDto>;
  updateHeyatVideoCommand?: Maybe<Response_HeyatVideoDto>;
  updateHeyatViewCountCommand?: Maybe<Response_UpdateHeyatViewCountDto>;
  updateHomeVideoViewCountCommand?: Maybe<Response_HomeViewCountDto>;
  updateLiveBroadCastSettingCommand?: Maybe<Response_LiveBroadCastSettingUpdateDto>;
};


export type HeyatMutationsChangeAlbumStatusCommandArgs = {
  request?: InputMaybe<InputMutationData_GalleryStatusDto>;
};


export type HeyatMutationsChangeHeyatStatusCommandArgs = {
  request?: InputMaybe<InputMutationData_HeyatStatusDto>;
};


export type HeyatMutationsChangeVideoStatusCommandArgs = {
  request?: InputMaybe<InputMutationData_GalleryStatusDto>;
};


export type HeyatMutationsCreateHeyatAlbumCommandArgs = {
  request?: InputMaybe<InputMutationData_HeyatAlbumDto>;
};


export type HeyatMutationsCreateHeyatCommandArgs = {
  request?: InputMaybe<InputMutationData_HeyatCreateReqDto>;
};


export type HeyatMutationsCreateHeyatVideoCommandArgs = {
  request?: InputMaybe<InputMutationData_HeyatVideoDto>;
};


export type HeyatMutationsDeleteHeyatAlbumCommandArgs = {
  request?: InputMaybe<InputMutationData_HeyatAlbumDeleteDto>;
};


export type HeyatMutationsDeleteHeyatCommandArgs = {
  request?: InputMaybe<InputMutationData_HeyatDeleteDto>;
};


export type HeyatMutationsDeleteHeyatVideoCommandArgs = {
  request?: InputMaybe<InputMutationData_HeyatVideoDeleteDto>;
};


export type HeyatMutationsDownloadVideoCommandArgs = {
  request?: InputMaybe<InputMutationData_DownloadVideoDto>;
};


export type HeyatMutationsGenerateLiveBroadCastSettingTokenCommandArgs = {
  request?: InputMaybe<InputMutationData_LiveBroadCastSettingTokenDto>;
};


export type HeyatMutationsUpdateHeyatAlbumCommandArgs = {
  request?: InputMaybe<InputMutationData_HeyatAlbumDto>;
};


export type HeyatMutationsUpdateHeyatCommandArgs = {
  request?: InputMaybe<InputMutationData_HeyatUpdateDto>;
};


export type HeyatMutationsUpdateHeyatVideoCommandArgs = {
  request?: InputMaybe<InputMutationData_HeyatVideoDto>;
};


export type HeyatMutationsUpdateHeyatViewCountCommandArgs = {
  request?: InputMaybe<InputMutationData_UpdateHeyatViewCountDto>;
};


export type HeyatMutationsUpdateHomeVideoViewCountCommandArgs = {
  request?: InputMaybe<InputMutationData_HomeViewCountDto>;
};


export type HeyatMutationsUpdateLiveBroadCastSettingCommandArgs = {
  request?: InputMaybe<InputMutationData_LiveBroadCastSettingUpdateDto>;
};

export type HeyatProgramMutations = {
  __typename?: 'HeyatProgramMutations';
  forceStopCommand?: Maybe<Response_HeyatProgramRecorderDto>;
};


export type HeyatProgramMutationsForceStopCommandArgs = {
  request?: InputMaybe<InputMutationData_HeyatProgramRecorderDto>;
};

export type HeyatProgramQueries = {
  __typename?: 'HeyatProgramQueries';
  checkEncoderQuery?: Maybe<Response_CheckEncoderDto>;
};


export type HeyatProgramQueriesCheckEncoderQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_CheckEncoderDto>;
};

export type HeyatQueries = {
  __typename?: 'HeyatQueries';
  adminAlbumGalleriesQuery?: Maybe<Response_AdminGalleryDto>;
  adminVideoGalleriesQuery?: Maybe<Response_AdminGalleryDto>;
  getHeyatAlbumsQuery?: Maybe<Response_HeyatAlbumDto>;
  getHeyatVideosQuery?: Maybe<Response_HeyatVideoReadDto>;
  getHeyatsQuery?: Maybe<Response_HeyatReadDto>;
  getLiveBroadCastSettingQuery?: Maybe<Response_LiveBroadCastSettingReadResDto>;
  getLiveProgramsQuery?: Maybe<Response_HeyatLiveProgramDto>;
  getNoticeHeyatsQuery?: Maybe<Response_HeyatDto>;
  getSliderHeyatsQuery?: Maybe<Response_SliderHeyatDto>;
  heyatDetailsQuery?: Maybe<Response_HomeHeyatDetailResDto>;
  homeAlbumsQuery?: Maybe<Response_HomeAlbumItemDto>;
  homeHeyatDetailsQuery?: Maybe<Response_HomeHeyatDetailResDto>;
  homeHeyatProgramsQuery?: Maybe<Response_HomeProgramDto>;
  homeHeyatProgramsSearchQuery?: Maybe<Response_HomeProgramSearchResDto>;
  homeHeyatsForSearchVideoQuery?: Maybe<Response_HomeHeyatsForSearchVideoResDto>;
  homeIndicatorHeyatsQuery?: Maybe<Response_HomeIndicatorHeyatDto>;
  homeNotRelatedVideosQuery?: Maybe<Response_HomeVideoItemDto>;
  homeRelatedVideosQuery?: Maybe<Response_HomeVideoItemDto>;
  homeVideosQuery?: Maybe<Response_HomeVideoItemDto>;
};


export type HeyatQueriesAdminAlbumGalleriesQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_AdminGalleryDto>;
};


export type HeyatQueriesAdminVideoGalleriesQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_AdminGalleryDto>;
};


export type HeyatQueriesGetHeyatAlbumsQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_HeyatAlbumDto>;
};


export type HeyatQueriesGetHeyatVideosQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_HeyatVideoReadDto>;
};


export type HeyatQueriesGetHeyatsQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_HeyatReadReqDto>;
};


export type HeyatQueriesGetLiveBroadCastSettingQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_LiveBroadCastSettingReadReqDto>;
};


export type HeyatQueriesGetLiveProgramsQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_HeyatLiveProgramDto>;
};


export type HeyatQueriesGetNoticeHeyatsQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_HeyatDto>;
};


export type HeyatQueriesGetSliderHeyatsQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_SliderHeyatDto>;
};


export type HeyatQueriesHeyatDetailsQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_HomeHeyatDetailReqDto>;
};


export type HeyatQueriesHomeAlbumsQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_HomeAlbumReqDto>;
};


export type HeyatQueriesHomeHeyatDetailsQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_HomeHeyatDetailReqDto>;
};


export type HeyatQueriesHomeHeyatProgramsQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_HomeProgramDto>;
};


export type HeyatQueriesHomeHeyatProgramsSearchQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_HomeProgramSearchReqDto>;
};


export type HeyatQueriesHomeHeyatsForSearchVideoQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_HomeHeyatsForSearchVideoReqDto>;
};


export type HeyatQueriesHomeIndicatorHeyatsQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_HomeIndicatorHeyatDto>;
};


export type HeyatQueriesHomeNotRelatedVideosQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_HomeVideoReqDto>;
};


export type HeyatQueriesHomeRelatedVideosQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_HomeVideoReqDto>;
};


export type HeyatQueriesHomeVideosQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_HomeVideoReqDto>;
};

export enum HeyatStatus {
  Confirmed = 'CONFIRMED',
  Pending = 'PENDING',
  Reject = 'REJECT'
}

export type InputMutationData_AdvertisementUpdateDto = {
  dto?: InputMaybe<Input_AdvertisementUpdateDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_ArchiveDeleteDto = {
  dto?: InputMaybe<Input_ArchiveDeleteDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_ArchiveUpdateDto = {
  dto?: InputMaybe<Input_ArchiveUpdateDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_ArchiveViewCountUpdateDto = {
  dto?: InputMaybe<Input_ArchiveViewCountUpdateDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_AvatarDto = {
  dto?: InputMaybe<Input_AvatarDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_BlockUserDto = {
  dto?: InputMaybe<Input_BlockUserDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_BlogContentCategoryCreateDto = {
  dto?: InputMaybe<Input_BlogContentCategoryCreateDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_BlogContentCategoryDeleteDto = {
  dto?: InputMaybe<Input_BlogContentCategoryDeleteDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_BlogContentCategoryUpdateDto = {
  dto?: InputMaybe<Input_BlogContentCategoryUpdateDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_BlogCreateDto = {
  dto?: InputMaybe<Input_BlogCreateDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_BlogDeleteDto = {
  dto?: InputMaybe<Input_BlogDeleteDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_BlogUpdateDto = {
  dto?: InputMaybe<Input_BlogUpdateDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_ChangePasswordReqDto = {
  dto?: InputMaybe<Input_ChangePasswordReqDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_ChangePhoneNumberReqDto = {
  dto?: InputMaybe<Input_ChangePhoneNumberReqDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_CmsTagDeleteDto = {
  dto?: InputMaybe<Input_CmsTagDeleteDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_CmsTagDto = {
  dto?: InputMaybe<Input_CmsTagDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_ContactUnAuthorizedUsCreateDto = {
  dto?: InputMaybe<Input_ContactUnAuthorizedUsCreateDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_ContactUsCreateDto = {
  dto?: InputMaybe<Input_ContactUsCreateDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_ContactUsDeleteDto = {
  dto?: InputMaybe<Input_ContactUsDeleteDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_ContactUsUpdateDto = {
  dto?: InputMaybe<Input_ContactUsUpdateDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_DownloadVideoDto = {
  dto?: InputMaybe<Input_DownloadVideoDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_FaqDeleteDto = {
  dto?: InputMaybe<Input_FaqDeleteDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_FaqDto = {
  dto?: InputMaybe<Input_FaqDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_FileDeleteDto = {
  dto?: InputMaybe<Input_FileDeleteDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_FileReqDto = {
  dto?: InputMaybe<Input_FileReqDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_ForceChangePasswordDto = {
  dto?: InputMaybe<Input_ForceChangePasswordDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_GalleryStatusDto = {
  dto?: InputMaybe<Input_GalleryStatusDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_HaramDeleteDto = {
  dto?: InputMaybe<Input_HaramDeleteDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_HaramDto = {
  dto?: InputMaybe<Input_HaramDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_HeyatAlbumDeleteDto = {
  dto?: InputMaybe<Input_HeyatAlbumDeleteDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_HeyatAlbumDto = {
  dto?: InputMaybe<Input_HeyatAlbumDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_HeyatCreateReqDto = {
  dto?: InputMaybe<Input_HeyatCreateReqDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_HeyatDeleteDto = {
  dto?: InputMaybe<Input_HeyatDeleteDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_HeyatProgramRecorderDto = {
  dto?: InputMaybe<Input_HeyatProgramRecorderDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_HeyatStatusDto = {
  dto?: InputMaybe<Input_HeyatStatusDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_HeyatUpdateDto = {
  dto?: InputMaybe<Input_HeyatUpdateDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_HeyatVideoDeleteDto = {
  dto?: InputMaybe<Input_HeyatVideoDeleteDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_HeyatVideoDto = {
  dto?: InputMaybe<Input_HeyatVideoDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_HomeRegisterReqDto = {
  dto?: InputMaybe<Input_HomeRegisterReqDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_HomeViewCountDto = {
  dto?: InputMaybe<Input_HomeViewCountDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_LanguageDto = {
  dto?: InputMaybe<Input_LanguageDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_LanguageTranslationDto = {
  dto?: InputMaybe<Input_LanguageTranslationDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_LikeEntityDto = {
  dto?: InputMaybe<Input_LikeEntityDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_LiveBroadCastSettingTokenDto = {
  dto?: InputMaybe<Input_LiveBroadCastSettingTokenDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_LiveBroadCastSettingUpdateDto = {
  dto?: InputMaybe<Input_LiveBroadCastSettingUpdateDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_NewsContentCategoryCreateDto = {
  dto?: InputMaybe<Input_NewsContentCategoryCreateDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_NewsContentCategoryDeleteDto = {
  dto?: InputMaybe<Input_NewsContentCategoryDeleteDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_NewsContentCategoryUpdateDto = {
  dto?: InputMaybe<Input_NewsContentCategoryUpdateDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_NewsCreateDto = {
  dto?: InputMaybe<Input_NewsCreateDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_NewsDeleteDto = {
  dto?: InputMaybe<Input_NewsDeleteDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_NewsUpdateDto = {
  dto?: InputMaybe<Input_NewsUpdateDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_NoticeDeleteDto = {
  dto?: InputMaybe<Input_NoticeDeleteDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_NoticeDto = {
  dto?: InputMaybe<Input_NoticeDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_OccasionCreateDto = {
  dto?: InputMaybe<Input_OccasionCreateDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_OccasionUpdateDto = {
  dto?: InputMaybe<Input_OccasionUpdateDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_OccasionsDeleteDto = {
  dto?: InputMaybe<Input_OccasionsDeleteDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_PageDeleteDto = {
  dto?: InputMaybe<Input_PageDeleteDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_PageDto = {
  dto?: InputMaybe<Input_PageDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_ProfileDto = {
  dto?: InputMaybe<Input_ProfileDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_QuranDeleteDto = {
  dto?: InputMaybe<Input_QuranDeleteDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_QuranDto = {
  dto?: InputMaybe<Input_QuranDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_RegisterUserDto = {
  dto?: InputMaybe<Input_RegisterUserDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_ResetForgotPasswordReqDto = {
  dto?: InputMaybe<Input_ResetForgotPasswordReqDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_ServerCreateDto = {
  dto?: InputMaybe<Input_ServerCreateDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_ServerDeleteDto = {
  dto?: InputMaybe<Input_ServerDeleteDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_ServerSetting = {
  dto?: InputMaybe<Input_ServerSetting>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_ServerUpdateDto = {
  dto?: InputMaybe<Input_ServerUpdateDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_SettingDto = {
  dto?: InputMaybe<Input_SettingDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_SliderDeleteDto = {
  dto?: InputMaybe<Input_SliderDeleteDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_SliderDto = {
  dto?: InputMaybe<Input_SliderDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_SpeakerSingerDeleteDto = {
  dto?: InputMaybe<Input_SpeakerSingerDeleteDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_SpeakerSingerDto = {
  dto?: InputMaybe<Input_SpeakerSingerDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_TagDto = {
  dto?: InputMaybe<Input_TagDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_TicketBookmarkDto = {
  dto?: InputMaybe<Input_TicketBookmarkDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_TicketCreateByAdminDto = {
  dto?: InputMaybe<Input_TicketCreateByAdminDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_TicketCreateByUserDto = {
  dto?: InputMaybe<Input_TicketCreateByUserDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_TicketDeleteDto = {
  dto?: InputMaybe<Input_TicketDeleteDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_TicketMessageUpdateDto = {
  dto?: InputMaybe<Input_TicketMessageUpdateDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_TraditionalDeleteDto = {
  dto?: InputMaybe<Input_TraditionalDeleteDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_TraditionalEventCreateDto = {
  dto?: InputMaybe<Input_TraditionalEventCreateDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_TraditionalEventUpdateDto = {
  dto?: InputMaybe<Input_TraditionalEventUpdateDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_UpdateCmsTagDto = {
  dto?: InputMaybe<Input_UpdateCmsTagDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_UpdateHeyatViewCountDto = {
  dto?: InputMaybe<Input_UpdateHeyatViewCountDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_UserDto = {
  dto?: InputMaybe<Input_UserDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_UserSettings = {
  dto?: InputMaybe<Input_UserSettings>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_VerificationCodeReqDto = {
  dto?: InputMaybe<Input_VerificationCodeReqDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_VerificationHeyatAdminReqDto = {
  dto?: InputMaybe<Input_VerificationHeyatAdminReqDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_VerificationHomeRegisterDto = {
  dto?: InputMaybe<Input_VerificationHomeRegisterDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_VerificationReqDto = {
  dto?: InputMaybe<Input_VerificationReqDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_ViewConfigDto = {
  dto?: InputMaybe<Input_ViewConfigDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_ViewerJoinDto = {
  dto?: InputMaybe<Input_ViewerJoinDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_ViolationReportCreateDto = {
  dto?: InputMaybe<Input_ViolationReportCreateDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_ViolationReportDeleteDto = {
  dto?: InputMaybe<Input_ViolationReportDeleteDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_ViolationReportUpdateDto = {
  dto?: InputMaybe<Input_ViolationReportUpdateDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputMutationData_VisitEntityDto = {
  dto?: InputMaybe<Input_VisitEntityDto>;
  externalIncludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  ignoreGetResponse?: InputMaybe<Scalars['Boolean']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_AdminGalleryDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_AdminGalleryDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_AdvertisementDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_AdvertisementDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_ArchiveProgressReqDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_ArchiveProgressReqDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_ArchiveReadDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_ArchiveReadDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_BlogContentCategoryQueryDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_BlogContentCategoryQueryDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_BlogQueryDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_BlogQueryDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_CheckEncoderDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_CheckEncoderDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_CheckStatusDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_CheckStatusDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_CityDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_CityDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_CmsTagDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_CmsTagDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_ContactUsReadDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_ContactUsReadDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_ContactUsUnitDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_ContactUsUnitDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_EntityViewersCountReqDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_EntityViewersCountReqDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_FaqReadDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_FaqReadDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_HaramDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_HaramDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_HeyatAlbumDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_HeyatAlbumDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_HeyatCityDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_HeyatCityDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_HeyatDashboardReportDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_HeyatDashboardReportDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_HeyatDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_HeyatDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_HeyatLanguageDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_HeyatLanguageDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_HeyatLiveProgramDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_HeyatLiveProgramDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_HeyatReadReqDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_HeyatReadReqDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_HeyatStateDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_HeyatStateDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_HeyatUserDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_HeyatUserDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_HeyatVideoOccasionDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_HeyatVideoOccasionDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_HeyatVideoReadDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_HeyatVideoReadDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_HomeAdvertisementDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_HomeAdvertisementDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_HomeAlbumReqDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_HomeAlbumReqDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_HomeChosenSpeakerSingerDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_HomeChosenSpeakerSingerDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_HomeFaqDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_HomeFaqDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_HomeHaramDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_HomeHaramDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_HomeHeyatDetailReqDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_HomeHeyatDetailReqDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_HomeHeyatsForSearchVideoReqDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_HomeHeyatsForSearchVideoReqDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_HomeIndicatorHeyatDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_HomeIndicatorHeyatDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_HomeNewsCategoryDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_HomeNewsCategoryDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_HomeNewsPageReqDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_HomeNewsPageReqDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_HomeNewsReqDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_HomeNewsReqDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_HomeOccasionDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_HomeOccasionDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_HomePageDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_HomePageDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_HomePageSpeakerSingerDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_HomePageSpeakerSingerDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_HomeProgramDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_HomeProgramDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_HomeProgramSearchReqDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_HomeProgramSearchReqDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_HomeQuranDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_HomeQuranDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_HomeSliderDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_HomeSliderDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_HomeVideoReqDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_HomeVideoReqDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_LanguageDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_LanguageDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_LanguageKeyDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_LanguageKeyDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_LanguageTranslationDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_LanguageTranslationDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_LikeEntityDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_LikeEntityDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_LiveBroadCastSettingReadReqDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_LiveBroadCastSettingReadReqDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_NewsContentCategoryQueryDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_NewsContentCategoryQueryDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_NewsDetailReqDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_NewsDetailReqDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_NewsQueryDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_NewsQueryDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_NoticeReadDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_NoticeReadDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_OccasionQueryDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_OccasionQueryDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_PageReadDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_PageReadDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_ProfileDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_ProfileDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_QuranDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_QuranDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_ResourcePermissionReqDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_ResourcePermissionReqDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_RoleDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_RoleDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_ServerReadDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_ServerReadDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_ServerSetting = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_ServerSetting>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_SettingDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_SettingDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_SliderHeyatDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_SliderHeyatDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_SliderReadDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_SliderReadDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_SpeakerSingerDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_SpeakerSingerDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_StateDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_StateDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_TagDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_TagDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_TempDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_TempDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_TicketMessageReadReqDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_TicketMessageReadReqDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_TicketReadReqDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_TicketReadReqDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_TicketRoleDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_TicketRoleDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_TicketUserDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_TicketUserDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_TraditionalEventQueryDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_TraditionalEventQueryDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_UserDashboardReportDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_UserDashboardReportDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_UserDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_UserDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_ViewConfigDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_ViewConfigDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_ViolationCategoryDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_ViolationCategoryDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InputQueryFilter_ViolationReportReadReqDto = {
  all?: InputMaybe<Scalars['Boolean']>;
  dto?: InputMaybe<Input_ViolationReportReadReqDto>;
  filterExpression?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']>>>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderByDescendings?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  orderByFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sessionKey?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type Input_AdminGalleryDto = {
  coverUrl?: InputMaybe<Scalars['String']>;
  dateTime?: InputMaybe<Scalars['DateTime']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  galleryStatus?: InputMaybe<GalleryStatus>;
  heyatId: Scalars['ID'];
  heyatName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  isArchive?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  videoUrl?: InputMaybe<Scalars['String']>;
  viewsCount?: InputMaybe<Scalars['Long']>;
};

export type Input_AdvertisementDto = {
  advertisementType: AdvertisementType;
  column: Scalars['Int'];
  id: Scalars['ID'];
  imageUrl?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<Scalars['String']>;
  published: Scalars['Boolean'];
  row: Scalars['Int'];
  title?: InputMaybe<Scalars['String']>;
  updatedDateTime: Scalars['DateTime'];
};

export type Input_AdvertisementUpdateDto = {
  advertisementType: AdvertisementType;
  id: Scalars['ID'];
  imageUrl?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<Scalars['String']>;
  published: Scalars['Boolean'];
  title?: InputMaybe<Scalars['String']>;
};

export type Input_ArchiveDeleteDto = {
  id: Scalars['ID'];
};

export type Input_ArchiveProgressReqDto = {
  archiveIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type Input_ArchiveReadDto = {
  createdDateTime?: InputMaybe<Scalars['DateTime']>;
  downloadLinkPath?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Seconds']>;
  heyatDto?: InputMaybe<Input_HeyatDto>;
  heyatName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  processStatus?: InputMaybe<ProcessStatus>;
  processStep?: InputMaybe<ProcessStep>;
  published: Scalars['Boolean'];
  serverReadDto?: InputMaybe<Input_ServerReadDto>;
  title?: InputMaybe<Scalars['String']>;
  updatedDateTime?: InputMaybe<Scalars['DateTime']>;
  viewCount: Scalars['Int'];
  webLinkPath?: InputMaybe<Scalars['String']>;
};

export type Input_ArchiveUpdateDto = {
  id: Scalars['ID'];
  processStatus: ProcessStatus;
  title?: InputMaybe<Scalars['String']>;
};

export type Input_ArchiveViewCountUpdateDto = {
  id: Scalars['ID'];
  viewCount?: InputMaybe<Scalars['Int']>;
};

export type Input_AvatarDto = {
  avatarUrl?: InputMaybe<Scalars['String']>;
};

export type Input_BlockUserDto = {
  block: Scalars['Boolean'];
  id?: InputMaybe<Scalars['String']>;
};

export type Input_BlogContentCategoryCreateDto = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  published: Scalars['Boolean'];
};

export type Input_BlogContentCategoryDeleteDto = {
  id: Scalars['ID'];
};

export type Input_BlogContentCategoryQueryDto = {
  createdDateTime?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  updatedDateTime?: InputMaybe<Scalars['DateTime']>;
};

export type Input_BlogContentCategoryUpdateDto = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  published: Scalars['Boolean'];
};

export type Input_BlogCreateDto = {
  blogContentCategoryId: Scalars['ID'];
  briefHistory?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  ownerFullName?: InputMaybe<Scalars['String']>;
  published: Scalars['Boolean'];
  tagIds?: InputMaybe<Array<Scalars['ID']>>;
  title?: InputMaybe<Scalars['String']>;
  webUrlDisplay?: InputMaybe<Scalars['String']>;
};

export type Input_BlogDeleteDto = {
  id: Scalars['ID'];
};

export type Input_BlogQueryDto = {
  blogContentCategory?: InputMaybe<Input_BlogContentCategoryQueryDto>;
  briefHistory?: InputMaybe<Scalars['String']>;
  createdDateTime?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  ownerFullName?: InputMaybe<Scalars['String']>;
  published: Scalars['Boolean'];
  tags?: InputMaybe<Array<InputMaybe<Input_CmsTagDto>>>;
  title?: InputMaybe<Scalars['String']>;
  updatedDateTime?: InputMaybe<Scalars['DateTime']>;
  webUrlDisplay?: InputMaybe<Scalars['String']>;
};

export type Input_BlogUpdateDto = {
  blogContentCategoryId: Scalars['ID'];
  briefHistory?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  ownerFullName?: InputMaybe<Scalars['String']>;
  published: Scalars['Boolean'];
  tagIds?: InputMaybe<Array<Scalars['ID']>>;
  title?: InputMaybe<Scalars['String']>;
  webUrlDisplay?: InputMaybe<Scalars['String']>;
};

export type Input_ChangePasswordReqDto = {
  confirmedNewPassword?: InputMaybe<Scalars['String']>;
  newPassword?: InputMaybe<Scalars['String']>;
  oldPassword?: InputMaybe<Scalars['String']>;
};

export type Input_ChangePhoneNumberReqDto = {
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type Input_CheckEncoderDto = {
  code?: InputMaybe<Scalars['Long']>;
  ok?: InputMaybe<Scalars['Boolean']>;
};

export type Input_CheckStatusDto = {
  entityType?: InputMaybe<Scalars['String']>;
  idList?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  statusList?: InputMaybe<Array<InputMaybe<Input_StatusDto>>>;
};

export type Input_CityDto = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  stateId?: InputMaybe<Scalars['ID']>;
};

export type Input_CmsTagDeleteDto = {
  id: Scalars['ID'];
};

export type Input_CmsTagDto = {
  createdDateTime?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  published?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  updatedDateTime?: InputMaybe<Scalars['DateTime']>;
};

export type Input_ContactUnAuthorizedUsCreateDto = {
  contactUsUnitId: Scalars['ID'];
  description?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type Input_ContactUsCreateDto = {
  contactUsUnitId: Scalars['ID'];
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type Input_ContactUsDeleteDto = {
  id: Scalars['ID'];
};

export type Input_ContactUsReadDto = {
  contactUsUnit?: InputMaybe<Input_ContactUsUnitDto>;
  createdDateTime: Scalars['DateTime'];
  description?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  updatedDateTime: Scalars['DateTime'];
};

export type Input_ContactUsUnitDto = {
  id: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
};

export type Input_ContactUsUpdateDto = {
  contactUsUnitId: Scalars['ID'];
  description?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type Input_DownloadVideoDto = {
  entityId: Scalars['ID'];
  identity?: InputMaybe<Scalars['String']>;
  totalDownloadsCount?: InputMaybe<Scalars['Long']>;
  uniqueDownloadsCount?: InputMaybe<Scalars['Long']>;
};

export type Input_EntityViewersCountReqDto = {
  codes?: InputMaybe<Array<Scalars['Long']>>;
  entityType: ViewerEntityType;
};

export type Input_FaqDeleteDto = {
  id: Scalars['ID'];
};

export type Input_FaqDto = {
  answer?: InputMaybe<Scalars['String']>;
  displayOrder?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  mobile?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  question?: InputMaybe<Scalars['String']>;
};

export type Input_FaqReadDto = {
  answer?: InputMaybe<Scalars['String']>;
  createdDateTime: Scalars['DateTime'];
  displayOrder: Scalars['Int'];
  id: Scalars['ID'];
  mobile: Scalars['Boolean'];
  published: Scalars['Boolean'];
  question?: InputMaybe<Scalars['String']>;
  updatedDateTime: Scalars['DateTime'];
};

export type Input_FileDeleteDto = {
  url?: InputMaybe<Scalars['String']>;
};

export type Input_FileReqDto = {
  binary?: InputMaybe<Scalars['String']>;
  entityType: EntityType;
  name?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type Input_ForceChangePasswordDto = {
  forceChangePassword: Scalars['Boolean'];
  id?: InputMaybe<Scalars['String']>;
};

export type Input_GalleryStatusDto = {
  galleryStatus: GalleryStatus;
  id: Scalars['ID'];
};

export type Input_HaramDeleteDto = {
  id: Scalars['ID'];
};

export type Input_HaramDto = {
  code?: InputMaybe<Scalars['Long']>;
  coverUrl?: InputMaybe<Scalars['String']>;
  createdDateTime?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  displayOrder?: InputMaybe<Scalars['Int']>;
  hasProxy?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  playbackLink?: InputMaybe<Scalars['String']>;
  proxyLink?: InputMaybe<Scalars['String']>;
  publishInHomePage?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  slugName?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedDateTime?: InputMaybe<Scalars['DateTime']>;
};

export type Input_HeyatAlbumDeleteDto = {
  id: Scalars['ID'];
};

export type Input_HeyatAlbumDto = {
  code?: InputMaybe<Scalars['Long']>;
  coverUrl?: InputMaybe<Scalars['String']>;
  createdDateTime?: InputMaybe<Scalars['DateTime']>;
  dateTime?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  displayOrder?: InputMaybe<Scalars['Int']>;
  galleryStatus?: InputMaybe<GalleryStatus>;
  heyatId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  publishInHomePage?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  updatedDateTime?: InputMaybe<Scalars['DateTime']>;
  viewsCount?: InputMaybe<Scalars['Long']>;
};

export type Input_HeyatCityDto = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  stateId?: InputMaybe<Scalars['ID']>;
};

export type Input_HeyatCreateReqDto = {
  archiveIndicator: Scalars['Boolean'];
  bannerUrl?: InputMaybe<Scalars['String']>;
  blueTick: Scalars['Boolean'];
  cityId: Scalars['ID'];
  displayOrder?: InputMaybe<Scalars['Int']>;
  headerUrl?: InputMaybe<Scalars['String']>;
  heyatStatus: HeyatStatus;
  highQualityBroadcast: Scalars['Boolean'];
  indicator: Scalars['Boolean'];
  isQuran: Scalars['Boolean'];
  isSystem: Scalars['Boolean'];
  languageId: Scalars['ID'];
  liveManagerUserId?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  managerFullName?: InputMaybe<Scalars['String']>;
  managerNationalCode?: InputMaybe<Scalars['String']>;
  managerPhoneNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  publishInHomePage?: InputMaybe<Scalars['Boolean']>;
  published: Scalars['Boolean'];
  registrationNumber?: InputMaybe<Scalars['String']>;
  singerId?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
  speakerId?: InputMaybe<Scalars['ID']>;
  stateId: Scalars['ID'];
};

export type Input_HeyatDashboardReportDto = {
  albumsCount: Scalars['Long'];
  heyatsCount: Scalars['Long'];
  liveHeyatsCount: Scalars['Long'];
  onlineHaramsCount: Scalars['Long'];
  onlineQuransCount: Scalars['Long'];
  pendingHeyatsCount: Scalars['Long'];
  videosCount: Scalars['Long'];
};

export type Input_HeyatDeleteDto = {
  id: Scalars['ID'];
};

export type Input_HeyatDto = {
  archiveIndicator: Scalars['Boolean'];
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type Input_HeyatLanguageDto = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type Input_HeyatLiveProgramDto = {
  code: Scalars['Long'];
  duration?: InputMaybe<Scalars['String']>;
  encoder?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  indicator: Scalars['Boolean'];
  is24HStream: Scalars['Boolean'];
  isOnline: Scalars['Boolean'];
  isOnlineBeta: Scalars['Boolean'];
  isTestStream: Scalars['Boolean'];
  liveBroadCastStartTime?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
  playerLink?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  startedDateTime?: InputMaybe<Scalars['DateTime']>;
  title?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  viewsCount: Scalars['Long'];
};

export type Input_HeyatProgramRecorderDto = {
  code: Scalars['Long'];
  filePath?: InputMaybe<Scalars['String']>;
};

export type Input_HeyatReadReqDto = {
  heyatStatus: HeyatStatus;
};

export type Input_HeyatStateDto = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Input_HeyatStatusDto = {
  heyatStatus: HeyatStatus;
  id: Scalars['ID'];
};

export type Input_HeyatUpdateDto = {
  archiveIndicator: Scalars['Boolean'];
  bannerUrl?: InputMaybe<Scalars['String']>;
  blueTick: Scalars['Boolean'];
  cityId: Scalars['ID'];
  displayOrder?: InputMaybe<Scalars['Int']>;
  headerUrl?: InputMaybe<Scalars['String']>;
  heyatStatus: HeyatStatus;
  highQualityBroadcast: Scalars['Boolean'];
  id: Scalars['ID'];
  indicator: Scalars['Boolean'];
  isQuran: Scalars['Boolean'];
  isSystem: Scalars['Boolean'];
  languageId: Scalars['ID'];
  liveManagerUserId?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  managerFullName?: InputMaybe<Scalars['String']>;
  managerNationalCode?: InputMaybe<Scalars['String']>;
  managerPhoneNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  publishInHomePage?: InputMaybe<Scalars['Boolean']>;
  published: Scalars['Boolean'];
  registrationNumber?: InputMaybe<Scalars['String']>;
  singerId?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
  speakerId?: InputMaybe<Scalars['ID']>;
  stateId: Scalars['ID'];
};

export type Input_HeyatUserDto = {
  fullName?: InputMaybe<Scalars['String']>;
  heyatId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['String']>;
  nationalCode?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type Input_HeyatVideoDeleteDto = {
  id: Scalars['ID'];
};

export type Input_HeyatVideoDto = {
  code?: InputMaybe<Scalars['Long']>;
  coverUrl?: InputMaybe<Scalars['String']>;
  dateTime?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  displayOrder?: InputMaybe<Scalars['Int']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  galleryStatus?: InputMaybe<GalleryStatus>;
  heyatId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  occasionId?: InputMaybe<Scalars['ID']>;
  publishInHomePage?: InputMaybe<Scalars['Boolean']>;
  published: Scalars['Boolean'];
  singerId?: InputMaybe<Scalars['ID']>;
  speakerId?: InputMaybe<Scalars['ID']>;
  tagIds?: InputMaybe<Array<Scalars['ID']>>;
  title?: InputMaybe<Scalars['String']>;
  totalDownloadsCount?: InputMaybe<Scalars['Long']>;
  uniqueDownloadsCount?: InputMaybe<Scalars['Long']>;
  videoUrl?: InputMaybe<Scalars['String']>;
};

export type Input_HeyatVideoOccasionDto = {
  id?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
};

export type Input_HeyatVideoReadDto = {
  code?: InputMaybe<Scalars['Long']>;
  coverUrl?: InputMaybe<Scalars['String']>;
  createdDateTime?: InputMaybe<Scalars['DateTime']>;
  dateTime?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  displayOrder?: InputMaybe<Scalars['Int']>;
  downloadUrl?: InputMaybe<Scalars['String']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  galleryStatus?: InputMaybe<GalleryStatus>;
  heyatId: Scalars['ID'];
  id?: InputMaybe<Scalars['ID']>;
  isArchive?: InputMaybe<Scalars['Boolean']>;
  occasion?: InputMaybe<Input_HeyatVideoOccasionDto>;
  playerUrl?: InputMaybe<Scalars['String']>;
  publishInHomePage?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  singer?: InputMaybe<Input_SpeakerSingerSelectDto>;
  speaker?: InputMaybe<Input_SpeakerSingerSelectDto>;
  tags?: InputMaybe<Array<InputMaybe<Input_TagDto>>>;
  title?: InputMaybe<Scalars['String']>;
  totalDownloadsCount?: InputMaybe<Scalars['Long']>;
  uniqueDownloadsCount?: InputMaybe<Scalars['Long']>;
  updatedDateTime?: InputMaybe<Scalars['DateTime']>;
  videoUrl?: InputMaybe<Scalars['String']>;
  viewsCount?: InputMaybe<Scalars['Long']>;
};

export type Input_HomeAdvertisementDto = {
  advertisementType?: InputMaybe<AdvertisementType>;
  column: Scalars['Int'];
  imageUrl?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<Scalars['String']>;
  row: Scalars['Int'];
  title?: InputMaybe<Scalars['String']>;
};

export type Input_HomeAlbumReqDto = {
  code?: InputMaybe<Scalars['Long']>;
  fromDate?: InputMaybe<Scalars['DateTime']>;
  toDate?: InputMaybe<Scalars['DateTime']>;
};

export type Input_HomeChosenSpeakerSingerDto = {
  avatarUrl?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['Long']>;
  fullName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  slug?: InputMaybe<Scalars['String']>;
  speakerSingerType?: InputMaybe<SpeakerSingerType>;
};

export type Input_HomeFaqDto = {
  answer?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['Boolean']>;
  question?: InputMaybe<Scalars['String']>;
};

export type Input_HomeHaramDto = {
  broadcastLink?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['Long']>;
  coverUrl?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  haramsPage?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  likesCount?: InputMaybe<Scalars['Long']>;
  slug?: InputMaybe<Scalars['String']>;
  slugName?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  viewsCount?: InputMaybe<Scalars['Long']>;
};

export type Input_HomeHeyatDetailReqDto = {
  code?: InputMaybe<Scalars['Long']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type Input_HomeHeyatsForSearchVideoReqDto = {
  searchKey?: InputMaybe<Scalars['String']>;
};

export type Input_HomeIndicatorHeyatDto = {
  bannerUrl?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['Long']>;
  id?: InputMaybe<Scalars['ID']>;
  isQuran?: InputMaybe<Scalars['Boolean']>;
  live?: InputMaybe<Scalars['Boolean']>;
  liveBroadCastStartTime?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  slugName?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  viewsCount?: InputMaybe<Scalars['Long']>;
};

export type Input_HomeNewsCategoryDto = {
  code: Scalars['Long'];
  displayOrder: Scalars['Int'];
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type Input_HomeNewsPageReqDto = {
  categoryCode?: InputMaybe<Scalars['Long']>;
  withMoreDetail: Scalars['Int'];
};

export type Input_HomeNewsReqDto = {
  withMoreDetail: Scalars['Int'];
};

export type Input_HomeOccasionDto = {
  description?: InputMaybe<Scalars['String']>;
  eventDateTime?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  occasionType?: InputMaybe<OccasionType>;
  title?: InputMaybe<Scalars['String']>;
};

export type Input_HomePageDto = {
  code?: InputMaybe<Scalars['Long']>;
  content?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type Input_HomePageSpeakerSingerDto = {
  avatarUrl?: InputMaybe<Scalars['String']>;
  birthDate?: InputMaybe<Scalars['DateTime']>;
  chosen?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['Long']>;
  deathDate?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  fatherName?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  originality?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  speakerSingerType?: InputMaybe<SpeakerSingerType>;
};

export type Input_HomeProgramDto = {
  code?: InputMaybe<Scalars['Long']>;
  dateTime?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isQuran?: InputMaybe<Scalars['Boolean']>;
  live?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  slugName?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  viewsCount?: InputMaybe<Scalars['Long']>;
};

export type Input_HomeProgramSearchReqDto = {
  isQuran?: InputMaybe<Scalars['Boolean']>;
  live?: InputMaybe<Scalars['Boolean']>;
  searchKey?: InputMaybe<Scalars['String']>;
  speakerSingerId?: InputMaybe<Scalars['ID']>;
};

export type Input_HomeQuranDto = {
  broadcastLink?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['Long']>;
  coverUrl?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  likesCount?: InputMaybe<Scalars['Long']>;
  quransPage?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  viewsCount?: InputMaybe<Scalars['Long']>;
};

export type Input_HomeRegisterReqDto = {
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type Input_HomeSliderDto = {
  imageUrl?: InputMaybe<Scalars['String']>;
  playbackLink?: InputMaybe<Scalars['String']>;
};

export type Input_HomeVideoReqDto = {
  code?: InputMaybe<Scalars['Long']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  fromDate?: InputMaybe<Scalars['DateTime']>;
  heyatCode?: InputMaybe<Scalars['Long']>;
  occasionId?: InputMaybe<Scalars['ID']>;
  occasionIds?: InputMaybe<Array<Scalars['ID']>>;
  singerId?: InputMaybe<Scalars['ID']>;
  speakerId?: InputMaybe<Scalars['ID']>;
  speakerSingerId?: InputMaybe<Scalars['ID']>;
  toDate?: InputMaybe<Scalars['DateTime']>;
};

export type Input_HomeViewCountDto = {
  id?: InputMaybe<Scalars['ID']>;
  viewsCount?: InputMaybe<Scalars['Long']>;
};

export type Input_LanguageDto = {
  flagUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  languageDirection?: InputMaybe<LanguageDirection>;
  languageTranslations?: InputMaybe<Array<InputMaybe<Input_LanguageTranslationDto>>>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type Input_LanguageKeyDto = {
  id?: InputMaybe<Scalars['ID']>;
  key?: InputMaybe<Scalars['String']>;
  languageId?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<Scalars['String']>;
};

export type Input_LanguageTranslationDto = {
  createdDateTime?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  key?: InputMaybe<Scalars['String']>;
  languageId?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<LanguageResourceType>;
  updatedDateTime?: InputMaybe<Scalars['DateTime']>;
  value?: InputMaybe<Scalars['String']>;
};

export type Input_LikeEntityDto = {
  entityId: Scalars['ID'];
  identity?: InputMaybe<Scalars['String']>;
  likeEntityType: LikeEntityType;
  liked?: InputMaybe<Scalars['Boolean']>;
  likesCount?: InputMaybe<Scalars['Long']>;
};

export type Input_LiveBroadCastSettingReadReqDto = {
  heyatId?: InputMaybe<Scalars['ID']>;
};

export type Input_LiveBroadCastSettingTokenDto = {
  heyatId?: InputMaybe<Scalars['ID']>;
  token?: InputMaybe<Scalars['String']>;
};

export type Input_LiveBroadCastSettingUpdateDto = {
  description?: InputMaybe<Scalars['String']>;
  heyatId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  is24HStream: Scalars['Boolean'];
  isTestStream: Scalars['Boolean'];
  liveBroadCastStartTime?: InputMaybe<Scalars['DateTime']>;
  singerId?: InputMaybe<Scalars['ID']>;
  speakerId?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};

export type Input_NewsContentCategoryCreateDto = {
  description?: InputMaybe<Scalars['String']>;
  displayOrder?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  published: Scalars['Boolean'];
};

export type Input_NewsContentCategoryDeleteDto = {
  id: Scalars['ID'];
};

export type Input_NewsContentCategoryQueryDto = {
  createdDateTime?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  displayOrder?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  updatedDateTime?: InputMaybe<Scalars['DateTime']>;
};

export type Input_NewsContentCategoryUpdateDto = {
  description?: InputMaybe<Scalars['String']>;
  displayOrder?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  published: Scalars['Boolean'];
};

export type Input_NewsCreateDto = {
  briefHistory?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  newsContentCategoryId: Scalars['ID'];
  ownerFullName?: InputMaybe<Scalars['String']>;
  published: Scalars['Boolean'];
  tagIds?: InputMaybe<Array<Scalars['ID']>>;
  title?: InputMaybe<Scalars['String']>;
  webUrlDisplay?: InputMaybe<Scalars['String']>;
};

export type Input_NewsDeleteDto = {
  id: Scalars['ID'];
};

export type Input_NewsDetailReqDto = {
  code: Scalars['Long'];
  relatedNews: Scalars['Int'];
};

export type Input_NewsQueryDto = {
  briefHistory?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['Long']>;
  createdDateTime?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  newsContentCategory?: InputMaybe<Input_NewsContentCategoryQueryDto>;
  ownerFullName?: InputMaybe<Scalars['String']>;
  published: Scalars['Boolean'];
  slug?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Input_CmsTagDto>>>;
  title?: InputMaybe<Scalars['String']>;
  updatedDateTime?: InputMaybe<Scalars['DateTime']>;
  webUrlDisplay?: InputMaybe<Scalars['String']>;
};

export type Input_NewsUpdateDto = {
  briefHistory?: InputMaybe<Scalars['String']>;
  createdDateTime?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  newsContentCategoryId: Scalars['ID'];
  ownerFullName?: InputMaybe<Scalars['String']>;
  published: Scalars['Boolean'];
  tagIds?: InputMaybe<Array<Scalars['ID']>>;
  title?: InputMaybe<Scalars['String']>;
  updatedDateTime?: InputMaybe<Scalars['DateTime']>;
  webUrlDisplay?: InputMaybe<Scalars['String']>;
};

export type Input_NoticeDeleteDto = {
  id: Scalars['ID'];
};

export type Input_NoticeDto = {
  content?: InputMaybe<Scalars['String']>;
  dateTime?: InputMaybe<Scalars['DateTime']>;
  heyatId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  noticeType: NoticeType;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Scalars['String']>;
  userPhoneNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_NoticeHeyatDto = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type Input_NoticeReadDto = {
  content?: InputMaybe<Scalars['String']>;
  createdDateTime: Scalars['DateTime'];
  dateTime?: InputMaybe<Scalars['DateTime']>;
  heyat?: InputMaybe<Input_NoticeHeyatDto>;
  id: Scalars['ID'];
  noticeType: NoticeType;
  receiver?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<InputMaybe<Input_NoticeRoleDto>>>;
  sent: Scalars['Boolean'];
  title?: InputMaybe<Scalars['String']>;
  updatedDateTime: Scalars['DateTime'];
  userPhoneNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Input_NoticeRoleDto = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Input_OccasionCreateDto = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  notificationText?: InputMaybe<Scalars['String']>;
  occasionType: OccasionType;
  published: Scalars['Boolean'];
  title?: InputMaybe<Scalars['String']>;
};

export type Input_OccasionQueryDto = {
  createdDateTime?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  eventDateTime?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  notificationText?: InputMaybe<Scalars['String']>;
  occasionType?: InputMaybe<OccasionType>;
  published?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  updatedDateTime?: InputMaybe<Scalars['DateTime']>;
};

export type Input_OccasionUpdateDto = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  notificationText?: InputMaybe<Scalars['String']>;
  occasionType: OccasionType;
  published: Scalars['Boolean'];
  title?: InputMaybe<Scalars['String']>;
};

export type Input_OccasionsDeleteDto = {
  id: Scalars['ID'];
};

export type Input_PageDeleteDto = {
  id: Scalars['ID'];
};

export type Input_PageDto = {
  content?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type Input_PageReadDto = {
  content?: InputMaybe<Scalars['String']>;
  createdDateTime: Scalars['DateTime'];
  id: Scalars['ID'];
  imageUrl?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedDateTime: Scalars['DateTime'];
};

export type Input_ProfileDto = {
  avatarUrl?: InputMaybe<Scalars['String']>;
  birthDate?: InputMaybe<Scalars['DateTime']>;
  forceChangePassword?: InputMaybe<Scalars['Boolean']>;
  forceCompleteProfile?: InputMaybe<Scalars['Boolean']>;
  fullName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lastLoginDateTime?: InputMaybe<Scalars['DateTime']>;
  nationalCode?: InputMaybe<Scalars['String']>;
  oneToLastLoginDateTime?: InputMaybe<Scalars['DateTime']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  roleDtos?: InputMaybe<Array<InputMaybe<Input_RoleDto>>>;
  userName?: InputMaybe<Scalars['String']>;
  userSettings?: InputMaybe<Input_UserSettings>;
};

export type Input_QuranDeleteDto = {
  id: Scalars['ID'];
};

export type Input_QuranDto = {
  code?: InputMaybe<Scalars['Long']>;
  coverUrl?: InputMaybe<Scalars['String']>;
  createdDateTime?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  displayOrder?: InputMaybe<Scalars['Int']>;
  hasProxy?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  playbackLink?: InputMaybe<Scalars['String']>;
  proxyLink?: InputMaybe<Scalars['String']>;
  publishInHomePage?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedDateTime?: InputMaybe<Scalars['DateTime']>;
};

export type Input_RegisterUserDto = {
  avatarUrl?: InputMaybe<Scalars['String']>;
  birthDate?: InputMaybe<Scalars['DateTime']>;
  fullName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  nationalCode?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  verificationCode?: InputMaybe<Scalars['String']>;
};

export type Input_ResetForgotPasswordReqDto = {
  confirmedPassword?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
};

export type Input_ResourceDto = {
  fileUrl?: InputMaybe<Scalars['String']>;
  hasChild: Scalars['Boolean'];
  id: Scalars['ID'];
  order: Scalars['Int'];
  parentId?: InputMaybe<Scalars['ID']>;
  resourceType: ResourceType;
  title?: InputMaybe<Scalars['String']>;
  uIResourceType: UiResourceType;
  value?: InputMaybe<Scalars['String']>;
};

export type Input_ResourcePermissionReqDto = {
  id: Scalars['ID'];
};

export type Input_RoleDto = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  resourceDtos?: InputMaybe<Array<InputMaybe<Input_ResourceDto>>>;
  userDtos?: InputMaybe<Array<InputMaybe<Input_UserDto>>>;
};

export type Input_ServerCreateDto = {
  coreCpu: Scalars['Int'];
  cpu: Scalars['Int'];
  endWorkDate?: InputMaybe<Scalars['DateTime']>;
  endWorkShift?: InputMaybe<Scalars['String']>;
  iP?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  isSpecial: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  published: Scalars['Boolean'];
  ram: Scalars['Int'];
  specialServerCanNotGetOtherFile: Scalars['Boolean'];
  startWorkDate?: InputMaybe<Scalars['DateTime']>;
  startWorkShift?: InputMaybe<Scalars['String']>;
};

export type Input_ServerDeleteDto = {
  id: Scalars['ID'];
};

export type Input_ServerReadDto = {
  coreCpu?: InputMaybe<Scalars['Int']>;
  cpu?: InputMaybe<Scalars['Int']>;
  createdDateTime?: InputMaybe<Scalars['DateTime']>;
  endWorkDate?: InputMaybe<Scalars['DateTime']>;
  endWorkShift?: InputMaybe<Scalars['String']>;
  iP?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  isSpecial: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  published: Scalars['Boolean'];
  ram?: InputMaybe<Scalars['Int']>;
  specialServerCanNotGetOtherFile: Scalars['Boolean'];
  startWorkDate?: InputMaybe<Scalars['DateTime']>;
  startWorkShift?: InputMaybe<Scalars['String']>;
  updatedDateTime?: InputMaybe<Scalars['DateTime']>;
};

export type Input_ServerSetting = {
  capacity: Scalars['Int'];
  useBeta: Scalars['Boolean'];
};

export type Input_ServerUpdateDto = {
  coreCpu: Scalars['Int'];
  cpu: Scalars['Int'];
  endWorkDate?: InputMaybe<Scalars['DateTime']>;
  endWorkShift?: InputMaybe<Scalars['String']>;
  iP?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  isSpecial: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  published: Scalars['Boolean'];
  ram: Scalars['Int'];
  specialServerCanNotGetOtherFile: Scalars['Boolean'];
  startWorkDate?: InputMaybe<Scalars['DateTime']>;
  startWorkShift?: InputMaybe<Scalars['String']>;
};

export type Input_SettingDto = {
  mobileTheme: ThemeMode;
  webTheme: ThemeMode;
};

export type Input_SimpleViewRange = {
  max: Scalars['Long'];
  min: Scalars['Long'];
  ratio: Scalars['Int'];
};

export type Input_SliderDeleteDto = {
  id: Scalars['ID'];
};

export type Input_SliderDto = {
  displayOrder?: InputMaybe<Scalars['Int']>;
  heyatId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  playbackLink?: InputMaybe<Scalars['String']>;
  publishInHomePage?: InputMaybe<Scalars['Boolean']>;
  published: Scalars['Boolean'];
  title?: InputMaybe<Scalars['String']>;
};

export type Input_SliderHeyatDto = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type Input_SliderReadDto = {
  createdDateTime: Scalars['DateTime'];
  displayOrder?: InputMaybe<Scalars['Int']>;
  heyat?: InputMaybe<Input_SliderHeyatDto>;
  id: Scalars['ID'];
  imageUrl?: InputMaybe<Scalars['String']>;
  playbackLink?: InputMaybe<Scalars['String']>;
  publishInHomePage?: InputMaybe<Scalars['Boolean']>;
  published: Scalars['Boolean'];
  title?: InputMaybe<Scalars['String']>;
  updatedDateTime: Scalars['DateTime'];
};

export type Input_SpeakerSingerDeleteDto = {
  id: Scalars['ID'];
};

export type Input_SpeakerSingerDto = {
  active?: InputMaybe<Scalars['Boolean']>;
  avatarUrl?: InputMaybe<Scalars['String']>;
  birthDate?: InputMaybe<Scalars['DateTime']>;
  chosen?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['Long']>;
  createdDateTime?: InputMaybe<Scalars['DateTime']>;
  deathDate?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  displayOrder?: InputMaybe<Scalars['Int']>;
  fatherName?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  heyats?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['ID']>;
  originality?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  publishInHomePage?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  speakerSingerType?: InputMaybe<SpeakerSingerType>;
  updatedDateTime?: InputMaybe<Scalars['DateTime']>;
};

export type Input_SpeakerSingerSelectDto = {
  fullName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type Input_StateDto = {
  cities?: InputMaybe<Array<InputMaybe<Input_CityDto>>>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Input_StatusDto = {
  id?: InputMaybe<Scalars['String']>;
  status: Scalars['Boolean'];
};

export type Input_TagDto = {
  id?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
};

export type Input_TempDto = {
  temp?: InputMaybe<Scalars['String']>;
};

export type Input_TicketBookmarkDto = {
  bookmark: Scalars['Boolean'];
  id: Scalars['ID'];
};

export type Input_TicketCreateByAdminDto = {
  attachments?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  ticketId?: InputMaybe<Scalars['ID']>;
  ticketMessageId?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type Input_TicketCreateByUserDto = {
  adminRoleId?: InputMaybe<Scalars['String']>;
  attachments?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  ticketId?: InputMaybe<Scalars['ID']>;
  ticketMessageId?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
};

export type Input_TicketDeleteDto = {
  id: Scalars['ID'];
};

export type Input_TicketMessageReadReqDto = {
  ticketId: Scalars['ID'];
};

export type Input_TicketMessageUpdateDto = {
  attachments?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
};

export type Input_TicketReadReqDto = {
  bookmarked?: InputMaybe<Scalars['Boolean']>;
  seen?: InputMaybe<Scalars['Boolean']>;
};

export type Input_TicketRoleDto = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Input_TicketUserDto = {
  fullName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type Input_TraditionalDeleteDto = {
  id: Scalars['ID'];
};

export type Input_TraditionalEventCreateDto = {
  eventDateTime?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  occasionId: Scalars['ID'];
};

export type Input_TraditionalEventQueryDto = {
  createdDateTime?: InputMaybe<Scalars['DateTime']>;
  eventDateTime?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  occasion?: InputMaybe<Input_OccasionQueryDto>;
  published?: InputMaybe<Scalars['Boolean']>;
  updatedDateTime?: InputMaybe<Scalars['DateTime']>;
};

export type Input_TraditionalEventUpdateDto = {
  eventDateTime?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  occasionId: Scalars['ID'];
};

export type Input_UpdateCmsTagDto = {
  id: Scalars['ID'];
  published: Scalars['Boolean'];
  title?: InputMaybe<Scalars['String']>;
};

export type Input_UpdateHeyatViewCountDto = {
  id?: InputMaybe<Scalars['ID']>;
  viewsCount?: InputMaybe<Scalars['Long']>;
};

export type Input_UserDashboardReportDto = {
  heyatAdminsCount: Scalars['Long'];
  loggedInHeyatAdminsCount: Scalars['Long'];
  notLoggedInHeyatAdminsCount: Scalars['Long'];
  usersCount: Scalars['Long'];
};

export type Input_UserDto = {
  avatarUrl?: InputMaybe<Scalars['String']>;
  birthDate?: InputMaybe<Scalars['DateTime']>;
  block?: InputMaybe<Scalars['Boolean']>;
  creationTime?: InputMaybe<Scalars['DateTime']>;
  filterRoleName?: InputMaybe<Scalars['String']>;
  forceChangePassword?: InputMaybe<Scalars['Boolean']>;
  fullName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lastLoginDateTime?: InputMaybe<Scalars['DateTime']>;
  lastModificationTime?: InputMaybe<Scalars['DateTime']>;
  nationalCode?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  roleDtos?: InputMaybe<Array<InputMaybe<Input_RoleDto>>>;
  userName?: InputMaybe<Scalars['String']>;
};

export type Input_UserSettings = {
  darkMode: Scalars['Boolean'];
  languageSlug?: InputMaybe<Scalars['String']>;
};

export type Input_VerificationCodeReqDto = {
  userName?: InputMaybe<Scalars['String']>;
};

export type Input_VerificationHeyatAdminReqDto = {
  code?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
};

export type Input_VerificationHomeRegisterDto = {
  code?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type Input_VerificationReqDto = {
  code?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  userName?: InputMaybe<Scalars['String']>;
};

export type Input_ViewConfigDto = {
  entityCode: Scalars['Long'];
  entityType: ViewerEntityType;
  published: Scalars['Boolean'];
  simpleVisitRange?: InputMaybe<Input_SimpleViewRange>;
};

export type Input_ViewerJoinDto = {
  entityCode: Scalars['Long'];
  entityType: ViewerEntityType;
  join: Scalars['Boolean'];
  userIdentifier?: InputMaybe<Scalars['String']>;
};

export type Input_ViolationCategoryDto = {
  id: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
};

export type Input_ViolationReportCreateDto = {
  description?: InputMaybe<Scalars['String']>;
  entityId: Scalars['ID'];
  id?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
  violationCategoryId: Scalars['ID'];
  violationEntityType: ViolationEntityType;
};

export type Input_ViolationReportDeleteDto = {
  id: Scalars['ID'];
};

export type Input_ViolationReportReadReqDto = {
  entityId: Scalars['ID'];
  violationEntityType: ViolationEntityType;
};

export type Input_ViolationReportUpdateDto = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  violationCategoryId: Scalars['ID'];
};

export type Input_VisitEntityDto = {
  entityId: Scalars['ID'];
  identity?: InputMaybe<Scalars['String']>;
  viewsCount?: InputMaybe<Scalars['Long']>;
  visitEntityType: VisitEntityType;
};

export enum LanguageDirection {
  Ltr = 'LTR',
  Rtl = 'RTL'
}

export type LanguageMutations = {
  __typename?: 'LanguageMutations';
  createLanguageTranslation?: Maybe<Response_LanguageTranslationDto>;
  defaultLanguage?: Maybe<Response_LanguageDto>;
  deleteLanguageTranslation?: Maybe<Response_LanguageTranslationDto>;
  updateLanguageTranslation?: Maybe<Response_LanguageTranslationDto>;
};


export type LanguageMutationsCreateLanguageTranslationArgs = {
  request?: InputMaybe<InputMutationData_LanguageTranslationDto>;
};


export type LanguageMutationsDefaultLanguageArgs = {
  request?: InputMaybe<InputMutationData_LanguageDto>;
};


export type LanguageMutationsDeleteLanguageTranslationArgs = {
  request?: InputMaybe<InputMutationData_LanguageTranslationDto>;
};


export type LanguageMutationsUpdateLanguageTranslationArgs = {
  request?: InputMaybe<InputMutationData_LanguageTranslationDto>;
};

export type LanguageQueries = {
  __typename?: 'LanguageQueries';
  heyatLanguages?: Maybe<Response_HeyatLanguageDto>;
  languageKeys?: Maybe<Response_LanguageKeyDto>;
  languageTranslations?: Maybe<Response_LanguageTranslationDto>;
  languages?: Maybe<Response_LanguageDto>;
};


export type LanguageQueriesHeyatLanguagesArgs = {
  filter?: InputMaybe<InputQueryFilter_HeyatLanguageDto>;
};


export type LanguageQueriesLanguageKeysArgs = {
  filter?: InputMaybe<InputQueryFilter_LanguageKeyDto>;
};


export type LanguageQueriesLanguageTranslationsArgs = {
  filter?: InputMaybe<InputQueryFilter_LanguageTranslationDto>;
};


export type LanguageQueriesLanguagesArgs = {
  filter?: InputMaybe<InputQueryFilter_LanguageDto>;
};

export enum LanguageResourceType {
  Form = 'FORM',
  Text = 'TEXT',
  ValidationTemplate = 'VALIDATION_TEMPLATE'
}

export enum LikeEntityType {
  Haram = 'HARAM',
  Heyat = 'HEYAT',
  HeyatAlbum = 'HEYAT_ALBUM',
  HeyatVideo = 'HEYAT_VIDEO',
  Quran = 'QURAN'
}

export type LikeMutations = {
  __typename?: 'LikeMutations';
  likeEntityCommand?: Maybe<Response_LikeEntityDto>;
};


export type LikeMutationsLikeEntityCommandArgs = {
  request?: InputMaybe<InputMutationData_LikeEntityDto>;
};

export type LikeQueries = {
  __typename?: 'LikeQueries';
  getIsLikedQuery?: Maybe<Response_LikeEntityDto>;
};


export type LikeQueriesGetIsLikedQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_LikeEntityDto>;
};

export type List_AdminEntityViewersCountDto = {
  __typename?: 'List_AdminEntityViewersCountDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_AdminEntityViewersCountDto>>>;
};

export type List_AdminGalleryDto = {
  __typename?: 'List_AdminGalleryDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_AdminGalleryDto>>>;
};

export type List_AdvertisementDto = {
  __typename?: 'List_AdvertisementDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_AdvertisementDto>>>;
};

export type List_AdvertisementUpdateDto = {
  __typename?: 'List_AdvertisementUpdateDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_AdvertisementUpdateDto>>>;
};

export type List_ArchiveDeleteDto = {
  __typename?: 'List_ArchiveDeleteDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_ArchiveDeleteDto>>>;
};

export type List_ArchiveProgressReportDto = {
  __typename?: 'List_ArchiveProgressReportDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_ArchiveProgressReportDto>>>;
};

export type List_ArchiveReadDto = {
  __typename?: 'List_ArchiveReadDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_ArchiveReadDto>>>;
};

export type List_ArchiveUpdateDto = {
  __typename?: 'List_ArchiveUpdateDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_ArchiveUpdateDto>>>;
};

export type List_ArchiveViewCountUpdateDto = {
  __typename?: 'List_ArchiveViewCountUpdateDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_ArchiveViewCountUpdateDto>>>;
};

export type List_AuthenticationDto = {
  __typename?: 'List_AuthenticationDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_AuthenticationDto>>>;
};

export type List_AvatarDto = {
  __typename?: 'List_AvatarDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_AvatarDto>>>;
};

export type List_BlockUserDto = {
  __typename?: 'List_BlockUserDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_BlockUserDto>>>;
};

export type List_BlogContentCategoryCreateDto = {
  __typename?: 'List_BlogContentCategoryCreateDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_BlogContentCategoryCreateDto>>>;
};

export type List_BlogContentCategoryDeleteDto = {
  __typename?: 'List_BlogContentCategoryDeleteDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_BlogContentCategoryDeleteDto>>>;
};

export type List_BlogContentCategoryQueryDto = {
  __typename?: 'List_BlogContentCategoryQueryDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_BlogContentCategoryQueryDto>>>;
};

export type List_BlogContentCategoryUpdateDto = {
  __typename?: 'List_BlogContentCategoryUpdateDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_BlogContentCategoryUpdateDto>>>;
};

export type List_BlogCreateDto = {
  __typename?: 'List_BlogCreateDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_BlogCreateDto>>>;
};

export type List_BlogDeleteDto = {
  __typename?: 'List_BlogDeleteDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_BlogDeleteDto>>>;
};

export type List_BlogQueryDto = {
  __typename?: 'List_BlogQueryDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_BlogQueryDto>>>;
};

export type List_BlogUpdateDto = {
  __typename?: 'List_BlogUpdateDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_BlogUpdateDto>>>;
};

export type List_ChangePasswordResDto = {
  __typename?: 'List_ChangePasswordResDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_ChangePasswordResDto>>>;
};

export type List_ChangePhoneNumberResDto = {
  __typename?: 'List_ChangePhoneNumberResDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_ChangePhoneNumberResDto>>>;
};

export type List_CheckEncoderDto = {
  __typename?: 'List_CheckEncoderDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_CheckEncoderDto>>>;
};

export type List_CheckStatusDto = {
  __typename?: 'List_CheckStatusDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_CheckStatusDto>>>;
};

export type List_CityDto = {
  __typename?: 'List_CityDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_CityDto>>>;
};

export type List_CmsTagDeleteDto = {
  __typename?: 'List_CmsTagDeleteDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_CmsTagDeleteDto>>>;
};

export type List_CmsTagDto = {
  __typename?: 'List_CmsTagDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_CmsTagDto>>>;
};

export type List_ContactUnAuthorizedUsCreateDto = {
  __typename?: 'List_ContactUnAuthorizedUsCreateDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_ContactUnAuthorizedUsCreateDto>>>;
};

export type List_ContactUsCreateDto = {
  __typename?: 'List_ContactUsCreateDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_ContactUsCreateDto>>>;
};

export type List_ContactUsDeleteDto = {
  __typename?: 'List_ContactUsDeleteDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_ContactUsDeleteDto>>>;
};

export type List_ContactUsReadDto = {
  __typename?: 'List_ContactUsReadDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_ContactUsReadDto>>>;
};

export type List_ContactUsUnitDto = {
  __typename?: 'List_ContactUsUnitDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_ContactUsUnitDto>>>;
};

export type List_ContactUsUpdateDto = {
  __typename?: 'List_ContactUsUpdateDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_ContactUsUpdateDto>>>;
};

export type List_DownloadVideoDto = {
  __typename?: 'List_DownloadVideoDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_DownloadVideoDto>>>;
};

export type List_EntityViewersCountDto = {
  __typename?: 'List_EntityViewersCountDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_EntityViewersCountDto>>>;
};

export type List_FaqDeleteDto = {
  __typename?: 'List_FAQDeleteDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_FaqDeleteDto>>>;
};

export type List_FaqDto = {
  __typename?: 'List_FAQDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_FaqDto>>>;
};

export type List_FaqReadDto = {
  __typename?: 'List_FAQReadDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_FaqReadDto>>>;
};

export type List_FileDeleteDto = {
  __typename?: 'List_FileDeleteDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_FileDeleteDto>>>;
};

export type List_FileResDto = {
  __typename?: 'List_FileResDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_FileResDto>>>;
};

export type List_ForceChangePasswordDto = {
  __typename?: 'List_ForceChangePasswordDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_ForceChangePasswordDto>>>;
};

export type List_GalleryStatusDto = {
  __typename?: 'List_GalleryStatusDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_GalleryStatusDto>>>;
};

export type List_HaramDeleteDto = {
  __typename?: 'List_HaramDeleteDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_HaramDeleteDto>>>;
};

export type List_HaramDto = {
  __typename?: 'List_HaramDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_HaramDto>>>;
};

export type List_HeyatAlbumDeleteDto = {
  __typename?: 'List_HeyatAlbumDeleteDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_HeyatAlbumDeleteDto>>>;
};

export type List_HeyatAlbumDto = {
  __typename?: 'List_HeyatAlbumDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_HeyatAlbumDto>>>;
};

export type List_HeyatCityDto = {
  __typename?: 'List_HeyatCityDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_HeyatCityDto>>>;
};

export type List_HeyatCreateResDto = {
  __typename?: 'List_HeyatCreateResDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_HeyatCreateResDto>>>;
};

export type List_HeyatDashboardReportDto = {
  __typename?: 'List_HeyatDashboardReportDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_HeyatDashboardReportDto>>>;
};

export type List_HeyatDeleteDto = {
  __typename?: 'List_HeyatDeleteDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_HeyatDeleteDto>>>;
};

export type List_HeyatDto = {
  __typename?: 'List_HeyatDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_HeyatDto>>>;
};

export type List_HeyatLanguageDto = {
  __typename?: 'List_HeyatLanguageDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_HeyatLanguageDto>>>;
};

export type List_HeyatLiveProgramDto = {
  __typename?: 'List_HeyatLiveProgramDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_HeyatLiveProgramDto>>>;
};

export type List_HeyatProgramRecorderDto = {
  __typename?: 'List_HeyatProgramRecorderDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_HeyatProgramRecorderDto>>>;
};

export type List_HeyatReadDto = {
  __typename?: 'List_HeyatReadDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_HeyatReadDto>>>;
};

export type List_HeyatStateDto = {
  __typename?: 'List_HeyatStateDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_HeyatStateDto>>>;
};

export type List_HeyatStatusDto = {
  __typename?: 'List_HeyatStatusDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_HeyatStatusDto>>>;
};

export type List_HeyatUpdateDto = {
  __typename?: 'List_HeyatUpdateDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_HeyatUpdateDto>>>;
};

export type List_HeyatUserDto = {
  __typename?: 'List_HeyatUserDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_HeyatUserDto>>>;
};

export type List_HeyatVideoDeleteDto = {
  __typename?: 'List_HeyatVideoDeleteDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_HeyatVideoDeleteDto>>>;
};

export type List_HeyatVideoDto = {
  __typename?: 'List_HeyatVideoDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_HeyatVideoDto>>>;
};

export type List_HeyatVideoOccasionDto = {
  __typename?: 'List_HeyatVideoOccasionDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_HeyatVideoOccasionDto>>>;
};

export type List_HeyatVideoReadDto = {
  __typename?: 'List_HeyatVideoReadDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_HeyatVideoReadDto>>>;
};

export type List_HomeAdvertisementDto = {
  __typename?: 'List_HomeAdvertisementDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_HomeAdvertisementDto>>>;
};

export type List_HomeAlbumItemDto = {
  __typename?: 'List_HomeAlbumItemDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_HomeAlbumItemDto>>>;
};

export type List_HomeChosenSpeakerSingerDto = {
  __typename?: 'List_HomeChosenSpeakerSingerDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_HomeChosenSpeakerSingerDto>>>;
};

export type List_HomeFaqDto = {
  __typename?: 'List_HomeFAQDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_HomeFaqDto>>>;
};

export type List_HomeHaramDto = {
  __typename?: 'List_HomeHaramDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_HomeHaramDto>>>;
};

export type List_HomeHeyatDetailResDto = {
  __typename?: 'List_HomeHeyatDetailResDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_HomeHeyatDetailResDto>>>;
};

export type List_HomeHeyatsForSearchVideoResDto = {
  __typename?: 'List_HomeHeyatsForSearchVideoResDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_HomeHeyatsForSearchVideoResDto>>>;
};

export type List_HomeIndicatorHeyatDto = {
  __typename?: 'List_HomeIndicatorHeyatDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_HomeIndicatorHeyatDto>>>;
};

export type List_HomeNewsCategoryDto = {
  __typename?: 'List_HomeNewsCategoryDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_HomeNewsCategoryDto>>>;
};

export type List_HomeNewsPageResDto = {
  __typename?: 'List_HomeNewsPageResDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_HomeNewsPageResDto>>>;
};

export type List_HomeNewsResDto = {
  __typename?: 'List_HomeNewsResDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_HomeNewsResDto>>>;
};

export type List_HomeOccasionDto = {
  __typename?: 'List_HomeOccasionDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_HomeOccasionDto>>>;
};

export type List_HomePageDto = {
  __typename?: 'List_HomePageDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_HomePageDto>>>;
};

export type List_HomePageSpeakerSingerDto = {
  __typename?: 'List_HomePageSpeakerSingerDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_HomePageSpeakerSingerDto>>>;
};

export type List_HomeProgramDto = {
  __typename?: 'List_HomeProgramDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_HomeProgramDto>>>;
};

export type List_HomeProgramSearchResDto = {
  __typename?: 'List_HomeProgramSearchResDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_HomeProgramSearchResDto>>>;
};

export type List_HomeQuranDto = {
  __typename?: 'List_HomeQuranDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_HomeQuranDto>>>;
};

export type List_HomeRegisterResDto = {
  __typename?: 'List_HomeRegisterResDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_HomeRegisterResDto>>>;
};

export type List_HomeSliderDto = {
  __typename?: 'List_HomeSliderDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_HomeSliderDto>>>;
};

export type List_HomeVideoItemDto = {
  __typename?: 'List_HomeVideoItemDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_HomeVideoItemDto>>>;
};

export type List_HomeViewCountDto = {
  __typename?: 'List_HomeViewCountDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_HomeViewCountDto>>>;
};

export type List_LanguageDto = {
  __typename?: 'List_LanguageDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_LanguageDto>>>;
};

export type List_LanguageKeyDto = {
  __typename?: 'List_LanguageKeyDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_LanguageKeyDto>>>;
};

export type List_LanguageTranslationDto = {
  __typename?: 'List_LanguageTranslationDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_LanguageTranslationDto>>>;
};

export type List_LikeEntityDto = {
  __typename?: 'List_LikeEntityDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_LikeEntityDto>>>;
};

export type List_LiveBroadCastSettingReadResDto = {
  __typename?: 'List_LiveBroadCastSettingReadResDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_LiveBroadCastSettingReadResDto>>>;
};

export type List_LiveBroadCastSettingTokenDto = {
  __typename?: 'List_LiveBroadCastSettingTokenDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_LiveBroadCastSettingTokenDto>>>;
};

export type List_LiveBroadCastSettingUpdateDto = {
  __typename?: 'List_LiveBroadCastSettingUpdateDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_LiveBroadCastSettingUpdateDto>>>;
};

export type List_NewsContentCategoryCreateDto = {
  __typename?: 'List_NewsContentCategoryCreateDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_NewsContentCategoryCreateDto>>>;
};

export type List_NewsContentCategoryDeleteDto = {
  __typename?: 'List_NewsContentCategoryDeleteDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_NewsContentCategoryDeleteDto>>>;
};

export type List_NewsContentCategoryQueryDto = {
  __typename?: 'List_NewsContentCategoryQueryDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_NewsContentCategoryQueryDto>>>;
};

export type List_NewsContentCategoryUpdateDto = {
  __typename?: 'List_NewsContentCategoryUpdateDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_NewsContentCategoryUpdateDto>>>;
};

export type List_NewsCreateDto = {
  __typename?: 'List_NewsCreateDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_NewsCreateDto>>>;
};

export type List_NewsDeleteDto = {
  __typename?: 'List_NewsDeleteDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_NewsDeleteDto>>>;
};

export type List_NewsDetailResDto = {
  __typename?: 'List_NewsDetailResDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_NewsDetailResDto>>>;
};

export type List_NewsQueryDto = {
  __typename?: 'List_NewsQueryDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_NewsQueryDto>>>;
};

export type List_NewsUpdateDto = {
  __typename?: 'List_NewsUpdateDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_NewsUpdateDto>>>;
};

export type List_NoticeDeleteDto = {
  __typename?: 'List_NoticeDeleteDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_NoticeDeleteDto>>>;
};

export type List_NoticeDto = {
  __typename?: 'List_NoticeDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_NoticeDto>>>;
};

export type List_NoticeReadDto = {
  __typename?: 'List_NoticeReadDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_NoticeReadDto>>>;
};

export type List_OccasionCreateDto = {
  __typename?: 'List_OccasionCreateDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_OccasionCreateDto>>>;
};

export type List_OccasionQueryDto = {
  __typename?: 'List_OccasionQueryDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_OccasionQueryDto>>>;
};

export type List_OccasionUpdateDto = {
  __typename?: 'List_OccasionUpdateDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_OccasionUpdateDto>>>;
};

export type List_OccasionsDeleteDto = {
  __typename?: 'List_OccasionsDeleteDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_OccasionsDeleteDto>>>;
};

export type List_PageDeleteDto = {
  __typename?: 'List_PageDeleteDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_PageDeleteDto>>>;
};

export type List_PageDto = {
  __typename?: 'List_PageDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_PageDto>>>;
};

export type List_PageReadDto = {
  __typename?: 'List_PageReadDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_PageReadDto>>>;
};

export type List_ProfileDto = {
  __typename?: 'List_ProfileDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_ProfileDto>>>;
};

export type List_QuranDeleteDto = {
  __typename?: 'List_QuranDeleteDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_QuranDeleteDto>>>;
};

export type List_QuranDto = {
  __typename?: 'List_QuranDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_QuranDto>>>;
};

export type List_RegisterUserDto = {
  __typename?: 'List_RegisterUserDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_RegisterUserDto>>>;
};

export type List_ResetForgotPasswordResDto = {
  __typename?: 'List_ResetForgotPasswordResDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_ResetForgotPasswordResDto>>>;
};

export type List_ResourcePermissionResDto = {
  __typename?: 'List_ResourcePermissionResDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_ResourcePermissionResDto>>>;
};

export type List_RoleDto = {
  __typename?: 'List_RoleDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_RoleDto>>>;
};

export type List_ServerCreateDto = {
  __typename?: 'List_ServerCreateDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_ServerCreateDto>>>;
};

export type List_ServerDeleteDto = {
  __typename?: 'List_ServerDeleteDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_ServerDeleteDto>>>;
};

export type List_ServerReadDto = {
  __typename?: 'List_ServerReadDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_ServerReadDto>>>;
};

export type List_ServerSetting = {
  __typename?: 'List_ServerSetting';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_ServerSetting>>>;
};

export type List_ServerUpdateDto = {
  __typename?: 'List_ServerUpdateDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_ServerUpdateDto>>>;
};

export type List_SettingDto = {
  __typename?: 'List_SettingDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_SettingDto>>>;
};

export type List_SliderDeleteDto = {
  __typename?: 'List_SliderDeleteDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_SliderDeleteDto>>>;
};

export type List_SliderDto = {
  __typename?: 'List_SliderDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_SliderDto>>>;
};

export type List_SliderHeyatDto = {
  __typename?: 'List_SliderHeyatDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_SliderHeyatDto>>>;
};

export type List_SliderReadDto = {
  __typename?: 'List_SliderReadDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_SliderReadDto>>>;
};

export type List_SpeakerSingerDeleteDto = {
  __typename?: 'List_SpeakerSingerDeleteDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_SpeakerSingerDeleteDto>>>;
};

export type List_SpeakerSingerDto = {
  __typename?: 'List_SpeakerSingerDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_SpeakerSingerDto>>>;
};

export type List_StateDto = {
  __typename?: 'List_StateDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_StateDto>>>;
};

export type List_TagDto = {
  __typename?: 'List_TagDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_TagDto>>>;
};

export type List_TempDto = {
  __typename?: 'List_TempDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_TempDto>>>;
};

export type List_TicketBookmarkDto = {
  __typename?: 'List_TicketBookmarkDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_TicketBookmarkDto>>>;
};

export type List_TicketCreateByAdminDto = {
  __typename?: 'List_TicketCreateByAdminDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_TicketCreateByAdminDto>>>;
};

export type List_TicketCreateByUserDto = {
  __typename?: 'List_TicketCreateByUserDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_TicketCreateByUserDto>>>;
};

export type List_TicketDeleteDto = {
  __typename?: 'List_TicketDeleteDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_TicketDeleteDto>>>;
};

export type List_TicketMessageUpdateDto = {
  __typename?: 'List_TicketMessageUpdateDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_TicketMessageUpdateDto>>>;
};

export type List_TicketOfMessageResDto = {
  __typename?: 'List_TicketOfMessageResDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_TicketOfMessageResDto>>>;
};

export type List_TicketReadResDto = {
  __typename?: 'List_TicketReadResDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_TicketReadResDto>>>;
};

export type List_TicketRoleDto = {
  __typename?: 'List_TicketRoleDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_TicketRoleDto>>>;
};

export type List_TicketUserDto = {
  __typename?: 'List_TicketUserDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_TicketUserDto>>>;
};

export type List_TraditionalDeleteDto = {
  __typename?: 'List_TraditionalDeleteDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_TraditionalDeleteDto>>>;
};

export type List_TraditionalEventCreateDto = {
  __typename?: 'List_TraditionalEventCreateDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_TraditionalEventCreateDto>>>;
};

export type List_TraditionalEventQueryDto = {
  __typename?: 'List_TraditionalEventQueryDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_TraditionalEventQueryDto>>>;
};

export type List_TraditionalEventUpdateDto = {
  __typename?: 'List_TraditionalEventUpdateDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_TraditionalEventUpdateDto>>>;
};

export type List_UpdateCmsTagDto = {
  __typename?: 'List_UpdateCmsTagDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_UpdateCmsTagDto>>>;
};

export type List_UpdateHeyatViewCountDto = {
  __typename?: 'List_UpdateHeyatViewCountDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_UpdateHeyatViewCountDto>>>;
};

export type List_UserDashboardReportDto = {
  __typename?: 'List_UserDashboardReportDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_UserDashboardReportDto>>>;
};

export type List_UserDto = {
  __typename?: 'List_UserDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_UserDto>>>;
};

export type List_UserSettings = {
  __typename?: 'List_UserSettings';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_UserSettings>>>;
};

export type List_VerificationCodeResDto = {
  __typename?: 'List_VerificationCodeResDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_VerificationCodeResDto>>>;
};

export type List_VerificationResDto = {
  __typename?: 'List_VerificationResDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_VerificationResDto>>>;
};

export type List_ViewConfigDto = {
  __typename?: 'List_ViewConfigDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_ViewConfigDto>>>;
};

export type List_ViewerJoinDto = {
  __typename?: 'List_ViewerJoinDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_ViewerJoinDto>>>;
};

export type List_ViolationCategoryDto = {
  __typename?: 'List_ViolationCategoryDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_ViolationCategoryDto>>>;
};

export type List_ViolationReportCreateDto = {
  __typename?: 'List_ViolationReportCreateDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_ViolationReportCreateDto>>>;
};

export type List_ViolationReportDeleteDto = {
  __typename?: 'List_ViolationReportDeleteDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_ViolationReportDeleteDto>>>;
};

export type List_ViolationReportReadResDto = {
  __typename?: 'List_ViolationReportReadResDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_ViolationReportReadResDto>>>;
};

export type List_ViolationReportUpdateDto = {
  __typename?: 'List_ViolationReportUpdateDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_ViolationReportUpdateDto>>>;
};

export type List_VisitEntityDto = {
  __typename?: 'List_VisitEntityDto';
  count?: Maybe<Scalars['Long']>;
  items?: Maybe<Array<Maybe<Output_VisitEntityDto>>>;
};

export type MonitoringMutations = {
  __typename?: 'MonitoringMutations';
  createViewConfigCommand?: Maybe<Response_ViewConfigDto>;
  joinViewerCommand?: Maybe<Response_ViewerJoinDto>;
};


export type MonitoringMutationsCreateViewConfigCommandArgs = {
  request?: InputMaybe<InputMutationData_ViewConfigDto>;
};


export type MonitoringMutationsJoinViewerCommandArgs = {
  request?: InputMaybe<InputMutationData_ViewerJoinDto>;
};

export type MonitoringQueries = {
  __typename?: 'MonitoringQueries';
  adminViewersCountQuery?: Maybe<Response_AdminEntityViewersCountDto>;
  archiveReportStatusQuery?: Maybe<Response_ArchiveProgressReportDto>;
  checkStatusQuery?: Maybe<Response_CheckStatusDto>;
  getViewConfigDetailQuery?: Maybe<Response_ViewConfigDto>;
  viewersCountQuery?: Maybe<Response_EntityViewersCountDto>;
};


export type MonitoringQueriesAdminViewersCountQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_EntityViewersCountReqDto>;
};


export type MonitoringQueriesArchiveReportStatusQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_ArchiveProgressReqDto>;
};


export type MonitoringQueriesCheckStatusQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_CheckStatusDto>;
};


export type MonitoringQueriesGetViewConfigDetailQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_ViewConfigDto>;
};


export type MonitoringQueriesViewersCountQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_EntityViewersCountReqDto>;
};

export type Mutations = {
  __typename?: 'Mutations';
  advertisementMutations?: Maybe<AdvertisementMutations>;
  archiveMutations?: Maybe<ArchiveMutations>;
  blogContentCategoryMutations?: Maybe<BlogContentCategoryMutations>;
  blogMutations?: Maybe<BlogMutations>;
  contactMutations?: Maybe<ContactMutations>;
  fAQMutations?: Maybe<FaqMutations>;
  fileMutations?: Maybe<FileMutations>;
  haramMutations?: Maybe<HaramMutations>;
  heyatMutations?: Maybe<HeyatMutations>;
  heyatProgramMutations?: Maybe<HeyatProgramMutations>;
  languageMutations?: Maybe<LanguageMutations>;
  likeMutations?: Maybe<LikeMutations>;
  monitoringMutations?: Maybe<MonitoringMutations>;
  newsContentCategoryMutations?: Maybe<NewsContentCategoryMutations>;
  newsMutations?: Maybe<NewsMutations>;
  noticeMutations?: Maybe<NoticeMutations>;
  occasionMutations?: Maybe<OccasionMutations>;
  pageMutations?: Maybe<PageMutations>;
  quranMutations?: Maybe<QuranMutations>;
  serverMutations?: Maybe<ServerMutations>;
  serverSettingMutations?: Maybe<ServerSettingMutations>;
  settingMutations?: Maybe<SettingMutations>;
  sliderMutations?: Maybe<SliderMutations>;
  speakerSingerMutations?: Maybe<SpeakerSingerMutations>;
  tagMutations?: Maybe<TagMutations>;
  ticketMutations?: Maybe<TicketMutations>;
  traditionalEventMutations?: Maybe<TraditionalEventMutations>;
  userMutations?: Maybe<UserMutations>;
  viewMutations?: Maybe<ViewMutations>;
  violationReportMutations?: Maybe<ViolationReportMutations>;
};

export type NewsContentCategoryMutations = {
  __typename?: 'NewsContentCategoryMutations';
  createNewsContentCategory?: Maybe<Response_NewsContentCategoryCreateDto>;
  deleteNewsContentCategoryCommand?: Maybe<Response_NewsContentCategoryDeleteDto>;
  updateNewsContentCategoryCommand?: Maybe<Response_NewsContentCategoryUpdateDto>;
};


export type NewsContentCategoryMutationsCreateNewsContentCategoryArgs = {
  request?: InputMaybe<InputMutationData_NewsContentCategoryCreateDto>;
};


export type NewsContentCategoryMutationsDeleteNewsContentCategoryCommandArgs = {
  request?: InputMaybe<InputMutationData_NewsContentCategoryDeleteDto>;
};


export type NewsContentCategoryMutationsUpdateNewsContentCategoryCommandArgs = {
  request?: InputMaybe<InputMutationData_NewsContentCategoryUpdateDto>;
};

export type NewsContentCategoryQueries = {
  __typename?: 'NewsContentCategoryQueries';
  newsContentCategories?: Maybe<Response_NewsContentCategoryQueryDto>;
};


export type NewsContentCategoryQueriesNewsContentCategoriesArgs = {
  filter?: InputMaybe<InputQueryFilter_NewsContentCategoryQueryDto>;
};

export type NewsMutations = {
  __typename?: 'NewsMutations';
  createNewsCommand?: Maybe<Response_NewsCreateDto>;
  deleteNewsCommand?: Maybe<Response_NewsDeleteDto>;
  updateNewsCommand?: Maybe<Response_NewsUpdateDto>;
};


export type NewsMutationsCreateNewsCommandArgs = {
  request?: InputMaybe<InputMutationData_NewsCreateDto>;
};


export type NewsMutationsDeleteNewsCommandArgs = {
  request?: InputMaybe<InputMutationData_NewsDeleteDto>;
};


export type NewsMutationsUpdateNewsCommandArgs = {
  request?: InputMaybe<InputMutationData_NewsUpdateDto>;
};

export type NewsQueries = {
  __typename?: 'NewsQueries';
  homeNewsCategoryQuery?: Maybe<Response_HomeNewsCategoryDto>;
  homeNewsPageQuery?: Maybe<Response_HomeNewsPageResDto>;
  homeNewsQuery?: Maybe<Response_HomeNewsResDto>;
  news?: Maybe<Response_NewsQueryDto>;
  newsDetailQuery?: Maybe<Response_NewsDetailResDto>;
};


export type NewsQueriesHomeNewsCategoryQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_HomeNewsCategoryDto>;
};


export type NewsQueriesHomeNewsPageQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_HomeNewsPageReqDto>;
};


export type NewsQueriesHomeNewsQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_HomeNewsReqDto>;
};


export type NewsQueriesNewsArgs = {
  filter?: InputMaybe<InputQueryFilter_NewsQueryDto>;
};


export type NewsQueriesNewsDetailQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_NewsDetailReqDto>;
};

export type NoticeMutations = {
  __typename?: 'NoticeMutations';
  createNoticeCommand?: Maybe<Response_NoticeDto>;
  deleteNoticeCommand?: Maybe<Response_NoticeDeleteDto>;
  updateNoticeCommand?: Maybe<Response_NoticeDto>;
};


export type NoticeMutationsCreateNoticeCommandArgs = {
  request?: InputMaybe<InputMutationData_NoticeDto>;
};


export type NoticeMutationsDeleteNoticeCommandArgs = {
  request?: InputMaybe<InputMutationData_NoticeDeleteDto>;
};


export type NoticeMutationsUpdateNoticeCommandArgs = {
  request?: InputMaybe<InputMutationData_NoticeDto>;
};

export type NoticeQueries = {
  __typename?: 'NoticeQueries';
  getNoticeQuery?: Maybe<Response_NoticeReadDto>;
};


export type NoticeQueriesGetNoticeQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_NoticeReadDto>;
};

export enum NoticeType {
  Both = 'BOTH',
  Firebase = 'FIREBASE',
  Sms = 'SMS'
}

export type OccasionMutations = {
  __typename?: 'OccasionMutations';
  createOccasionCommand?: Maybe<Response_OccasionCreateDto>;
  deleteOccasionCommand?: Maybe<Response_OccasionsDeleteDto>;
  updateOccasionCommand?: Maybe<Response_OccasionUpdateDto>;
};


export type OccasionMutationsCreateOccasionCommandArgs = {
  request?: InputMaybe<InputMutationData_OccasionCreateDto>;
};


export type OccasionMutationsDeleteOccasionCommandArgs = {
  request?: InputMaybe<InputMutationData_OccasionsDeleteDto>;
};


export type OccasionMutationsUpdateOccasionCommandArgs = {
  request?: InputMaybe<InputMutationData_OccasionUpdateDto>;
};

export type OccasionQueries = {
  __typename?: 'OccasionQueries';
  getOccasionQuery?: Maybe<Response_OccasionQueryDto>;
  heyatVideoOccasions?: Maybe<Response_HeyatVideoOccasionDto>;
  homeOccasionQuery?: Maybe<Response_HomeOccasionDto>;
};


export type OccasionQueriesGetOccasionQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_OccasionQueryDto>;
};


export type OccasionQueriesHeyatVideoOccasionsArgs = {
  filter?: InputMaybe<InputQueryFilter_HeyatVideoOccasionDto>;
};


export type OccasionQueriesHomeOccasionQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_HomeOccasionDto>;
};

export enum OccasionType {
  Happiness = 'HAPPINESS',
  Other = 'OTHER',
  Sorrow = 'SORROW'
}

export type Output_AdminEntityViewersCountDto = {
  __typename?: 'Output_AdminEntityViewersCountDto';
  entityType: ViewerEntityType;
  viewersCount?: Maybe<Array<Maybe<Output_AdminViewersCountDto>>>;
};

export type Output_AdminGalleryDto = {
  __typename?: 'Output_AdminGalleryDto';
  coverUrl?: Maybe<Scalars['String']>;
  dateTime?: Maybe<Scalars['DateTime']>;
  featured?: Maybe<Scalars['Boolean']>;
  galleryStatus?: Maybe<GalleryStatus>;
  heyatId: Scalars['ID'];
  heyatName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isArchive?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  videoUrl?: Maybe<Scalars['String']>;
  viewsCount?: Maybe<Scalars['Long']>;
};

export type Output_AdminViewersCountDto = {
  __typename?: 'Output_AdminViewersCountDto';
  calculatedCount: Scalars['Long'];
  code: Scalars['Long'];
  randomMin: Scalars['Long'];
  realCount: Scalars['Long'];
  totalCount: Scalars['Long'];
};

export type Output_AdvertisementDto = {
  __typename?: 'Output_AdvertisementDto';
  advertisementType: AdvertisementType;
  column: Scalars['Int'];
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  published: Scalars['Boolean'];
  row: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  updatedDateTime: Scalars['DateTime'];
};

export type Output_AdvertisementUpdateDto = {
  __typename?: 'Output_AdvertisementUpdateDto';
  advertisementType: AdvertisementType;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  published: Scalars['Boolean'];
  title?: Maybe<Scalars['String']>;
};

export type Output_ArchiveDeleteDto = {
  __typename?: 'Output_ArchiveDeleteDto';
  id: Scalars['ID'];
};

export type Output_ArchiveProgressReportDto = {
  __typename?: 'Output_ArchiveProgressReportDto';
  archiveId: Scalars['ID'];
  progressPercentage: Scalars['Float'];
  remainTime?: Maybe<Scalars['String']>;
};

export type Output_ArchiveReadDto = {
  __typename?: 'Output_ArchiveReadDto';
  createdDateTime?: Maybe<Scalars['DateTime']>;
  downloadLinkPath?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Seconds']>;
  heyatDto?: Maybe<Output_HeyatDto>;
  heyatName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  processStatus?: Maybe<ProcessStatus>;
  processStep?: Maybe<ProcessStep>;
  published: Scalars['Boolean'];
  serverReadDto?: Maybe<Output_ServerReadDto>;
  title?: Maybe<Scalars['String']>;
  updatedDateTime?: Maybe<Scalars['DateTime']>;
  viewCount: Scalars['Int'];
  webLinkPath?: Maybe<Scalars['String']>;
};

export type Output_ArchiveUpdateDto = {
  __typename?: 'Output_ArchiveUpdateDto';
  id: Scalars['ID'];
  processStatus: ProcessStatus;
  title?: Maybe<Scalars['String']>;
};

export type Output_ArchiveViewCountUpdateDto = {
  __typename?: 'Output_ArchiveViewCountUpdateDto';
  id: Scalars['ID'];
  viewCount?: Maybe<Scalars['Int']>;
};

export type Output_AuthenticationDto = {
  __typename?: 'Output_AuthenticationDto';
  access_token?: Maybe<Scalars['String']>;
  expires_in: Scalars['Int'];
  refresh_token?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  token_type?: Maybe<Scalars['String']>;
  user?: Maybe<Output_AuthenticationUserDto>;
};

export type Output_AuthenticationUserDto = {
  __typename?: 'Output_AuthenticationUserDto';
  id?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type Output_AvatarDto = {
  __typename?: 'Output_AvatarDto';
  avatarUrl?: Maybe<Scalars['String']>;
};

export type Output_BlockUserDto = {
  __typename?: 'Output_BlockUserDto';
  block: Scalars['Boolean'];
  id?: Maybe<Scalars['String']>;
};

export type Output_BlogContentCategoryCreateDto = {
  __typename?: 'Output_BlogContentCategoryCreateDto';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  published: Scalars['Boolean'];
};

export type Output_BlogContentCategoryDeleteDto = {
  __typename?: 'Output_BlogContentCategoryDeleteDto';
  id: Scalars['ID'];
};

export type Output_BlogContentCategoryQueryDto = {
  __typename?: 'Output_BlogContentCategoryQueryDto';
  createdDateTime?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  updatedDateTime?: Maybe<Scalars['DateTime']>;
};

export type Output_BlogContentCategoryUpdateDto = {
  __typename?: 'Output_BlogContentCategoryUpdateDto';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  published: Scalars['Boolean'];
};

export type Output_BlogCreateDto = {
  __typename?: 'Output_BlogCreateDto';
  blogContentCategoryId: Scalars['ID'];
  briefHistory?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  imageUrl?: Maybe<Scalars['String']>;
  ownerFullName?: Maybe<Scalars['String']>;
  published: Scalars['Boolean'];
  tagIds?: Maybe<Array<Scalars['ID']>>;
  title?: Maybe<Scalars['String']>;
  webUrlDisplay?: Maybe<Scalars['String']>;
};

export type Output_BlogDeleteDto = {
  __typename?: 'Output_BlogDeleteDto';
  id: Scalars['ID'];
};

export type Output_BlogQueryDto = {
  __typename?: 'Output_BlogQueryDto';
  blogContentCategory?: Maybe<Output_BlogContentCategoryQueryDto>;
  briefHistory?: Maybe<Scalars['String']>;
  createdDateTime?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  imageUrl?: Maybe<Scalars['String']>;
  ownerFullName?: Maybe<Scalars['String']>;
  published: Scalars['Boolean'];
  tags?: Maybe<Array<Maybe<Output_CmsTagDto>>>;
  title?: Maybe<Scalars['String']>;
  updatedDateTime?: Maybe<Scalars['DateTime']>;
  webUrlDisplay?: Maybe<Scalars['String']>;
};

export type Output_BlogUpdateDto = {
  __typename?: 'Output_BlogUpdateDto';
  blogContentCategoryId: Scalars['ID'];
  briefHistory?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  imageUrl?: Maybe<Scalars['String']>;
  ownerFullName?: Maybe<Scalars['String']>;
  published: Scalars['Boolean'];
  tagIds?: Maybe<Array<Scalars['ID']>>;
  title?: Maybe<Scalars['String']>;
  webUrlDisplay?: Maybe<Scalars['String']>;
};

export type Output_ChangePasswordResDto = {
  __typename?: 'Output_ChangePasswordResDto';
  id: Scalars['ID'];
};

export type Output_ChangePhoneNumberResDto = {
  __typename?: 'Output_ChangePhoneNumberResDto';
  id: Scalars['ID'];
};

export type Output_CheckEncoderDto = {
  __typename?: 'Output_CheckEncoderDto';
  code?: Maybe<Scalars['Long']>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type Output_CheckStatusDto = {
  __typename?: 'Output_CheckStatusDto';
  entityType?: Maybe<Scalars['String']>;
  idList?: Maybe<Array<Maybe<Scalars['String']>>>;
  statusList?: Maybe<Array<Maybe<Output_StatusDto>>>;
};

export type Output_CityDto = {
  __typename?: 'Output_CityDto';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  stateId?: Maybe<Scalars['ID']>;
};

export type Output_CmsTagDeleteDto = {
  __typename?: 'Output_CmsTagDeleteDto';
  id: Scalars['ID'];
};

export type Output_CmsTagDto = {
  __typename?: 'Output_CmsTagDto';
  createdDateTime?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  published?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  updatedDateTime?: Maybe<Scalars['DateTime']>;
};

export type Output_ContactUnAuthorizedUsCreateDto = {
  __typename?: 'Output_ContactUnAuthorizedUsCreateDto';
  contactUsUnitId: Scalars['ID'];
  description?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type Output_ContactUsCreateDto = {
  __typename?: 'Output_ContactUsCreateDto';
  contactUsUnitId: Scalars['ID'];
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

export type Output_ContactUsDeleteDto = {
  __typename?: 'Output_ContactUsDeleteDto';
  id: Scalars['ID'];
};

export type Output_ContactUsReadDto = {
  __typename?: 'Output_ContactUsReadDto';
  contactUsUnit?: Maybe<Output_ContactUsUnitDto>;
  createdDateTime: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  phoneNumber?: Maybe<Scalars['String']>;
  updatedDateTime: Scalars['DateTime'];
};

export type Output_ContactUsUnitDto = {
  __typename?: 'Output_ContactUsUnitDto';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
};

export type Output_ContactUsUpdateDto = {
  __typename?: 'Output_ContactUsUpdateDto';
  contactUsUnitId: Scalars['ID'];
  description?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  phoneNumber?: Maybe<Scalars['String']>;
};

export type Output_DownloadVideoDto = {
  __typename?: 'Output_DownloadVideoDto';
  entityId: Scalars['ID'];
  identity?: Maybe<Scalars['String']>;
  totalDownloadsCount?: Maybe<Scalars['Long']>;
  uniqueDownloadsCount?: Maybe<Scalars['Long']>;
};

export type Output_DownloadWithQuality = {
  __typename?: 'Output_DownloadWithQuality';
  downloadUrl?: Maybe<Scalars['String']>;
  quality?: Maybe<Scalars['String']>;
};

export type Output_EntityViewersCountDto = {
  __typename?: 'Output_EntityViewersCountDto';
  entityType: ViewerEntityType;
  viewersCount?: Maybe<Array<Maybe<Output_ViewersCountDto>>>;
};

export type Output_FaqDeleteDto = {
  __typename?: 'Output_FAQDeleteDto';
  id: Scalars['ID'];
};

export type Output_FaqDto = {
  __typename?: 'Output_FAQDto';
  answer?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  mobile?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  question?: Maybe<Scalars['String']>;
};

export type Output_FaqReadDto = {
  __typename?: 'Output_FAQReadDto';
  answer?: Maybe<Scalars['String']>;
  createdDateTime: Scalars['DateTime'];
  displayOrder: Scalars['Int'];
  id: Scalars['ID'];
  mobile: Scalars['Boolean'];
  published: Scalars['Boolean'];
  question?: Maybe<Scalars['String']>;
  updatedDateTime: Scalars['DateTime'];
};

export type Output_FileDeleteDto = {
  __typename?: 'Output_FileDeleteDto';
  url?: Maybe<Scalars['String']>;
};

export type Output_FileResDto = {
  __typename?: 'Output_FileResDto';
  url?: Maybe<Scalars['String']>;
};

export type Output_ForceChangePasswordDto = {
  __typename?: 'Output_ForceChangePasswordDto';
  forceChangePassword: Scalars['Boolean'];
  id?: Maybe<Scalars['String']>;
};

export type Output_GalleryStatusDto = {
  __typename?: 'Output_GalleryStatusDto';
  galleryStatus: GalleryStatus;
  id: Scalars['ID'];
};

export type Output_HaramDeleteDto = {
  __typename?: 'Output_HaramDeleteDto';
  id: Scalars['ID'];
};

export type Output_HaramDto = {
  __typename?: 'Output_HaramDto';
  code?: Maybe<Scalars['Long']>;
  coverUrl?: Maybe<Scalars['String']>;
  createdDateTime?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasProxy?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  playbackLink?: Maybe<Scalars['String']>;
  proxyLink?: Maybe<Scalars['String']>;
  publishInHomePage?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
  slugName?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedDateTime?: Maybe<Scalars['DateTime']>;
};

export type Output_HeyatAlbumDeleteDto = {
  __typename?: 'Output_HeyatAlbumDeleteDto';
  id: Scalars['ID'];
};

export type Output_HeyatAlbumDto = {
  __typename?: 'Output_HeyatAlbumDto';
  code?: Maybe<Scalars['Long']>;
  coverUrl?: Maybe<Scalars['String']>;
  createdDateTime?: Maybe<Scalars['DateTime']>;
  dateTime?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  galleryStatus?: Maybe<GalleryStatus>;
  heyatId?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  images?: Maybe<Array<Maybe<Scalars['String']>>>;
  publishInHomePage?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  updatedDateTime?: Maybe<Scalars['DateTime']>;
  viewsCount?: Maybe<Scalars['Long']>;
};

export type Output_HeyatCityDto = {
  __typename?: 'Output_HeyatCityDto';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  stateId?: Maybe<Scalars['ID']>;
};

export type Output_HeyatCreateResDto = {
  __typename?: 'Output_HeyatCreateResDto';
  id: Scalars['ID'];
};

export type Output_HeyatDashboardReportDto = {
  __typename?: 'Output_HeyatDashboardReportDto';
  albumsCount: Scalars['Long'];
  heyatsCount: Scalars['Long'];
  liveHeyatsCount: Scalars['Long'];
  onlineHaramsCount: Scalars['Long'];
  onlineQuransCount: Scalars['Long'];
  pendingHeyatsCount: Scalars['Long'];
  videosCount: Scalars['Long'];
};

export type Output_HeyatDeleteDto = {
  __typename?: 'Output_HeyatDeleteDto';
  id: Scalars['ID'];
};

export type Output_HeyatDto = {
  __typename?: 'Output_HeyatDto';
  archiveIndicator: Scalars['Boolean'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type Output_HeyatLanguageDto = {
  __typename?: 'Output_HeyatLanguageDto';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type Output_HeyatLiveProgramDto = {
  __typename?: 'Output_HeyatLiveProgramDto';
  code: Scalars['Long'];
  duration?: Maybe<Scalars['String']>;
  encoder?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  indicator: Scalars['Boolean'];
  is24HStream: Scalars['Boolean'];
  isOnline: Scalars['Boolean'];
  isOnlineBeta: Scalars['Boolean'];
  isTestStream: Scalars['Boolean'];
  liveBroadCastStartTime?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  playerLink?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  startedDateTime?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  viewsCount: Scalars['Long'];
};

export type Output_HeyatProgramRecorderDto = {
  __typename?: 'Output_HeyatProgramRecorderDto';
  code: Scalars['Long'];
  filePath?: Maybe<Scalars['String']>;
};

export type Output_HeyatReadDto = {
  __typename?: 'Output_HeyatReadDto';
  archiveIndicator: Scalars['Boolean'];
  bannerUrl?: Maybe<Scalars['String']>;
  blueTick: Scalars['Boolean'];
  city?: Maybe<Output_HeyatCityDto>;
  code: Scalars['Long'];
  createdDateTime?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Int']>;
  headerUrl?: Maybe<Scalars['String']>;
  heyatStatus: HeyatStatus;
  highQualityBroadcast: Scalars['Boolean'];
  id?: Maybe<Scalars['ID']>;
  indicator: Scalars['Boolean'];
  isQuran: Scalars['Boolean'];
  isSystem: Scalars['Boolean'];
  language?: Maybe<Output_HeyatLanguageDto>;
  liveManagerUser?: Maybe<Output_HeyatUserDto>;
  logoUrl?: Maybe<Scalars['String']>;
  managerFullName?: Maybe<Scalars['String']>;
  managerNationalCode?: Maybe<Scalars['String']>;
  managerPhoneNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  publishInHomePage?: Maybe<Scalars['Boolean']>;
  published: Scalars['Boolean'];
  registrationNumber?: Maybe<Scalars['String']>;
  singer?: Maybe<Output_SpeakerSingerDto>;
  slug?: Maybe<Scalars['String']>;
  speaker?: Maybe<Output_SpeakerSingerDto>;
  state?: Maybe<Output_HeyatStateDto>;
  updatedDateTime?: Maybe<Scalars['DateTime']>;
};

export type Output_HeyatStateDto = {
  __typename?: 'Output_HeyatStateDto';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type Output_HeyatStatusDto = {
  __typename?: 'Output_HeyatStatusDto';
  heyatStatus: HeyatStatus;
  id: Scalars['ID'];
};

export type Output_HeyatUpdateDto = {
  __typename?: 'Output_HeyatUpdateDto';
  archiveIndicator: Scalars['Boolean'];
  bannerUrl?: Maybe<Scalars['String']>;
  blueTick: Scalars['Boolean'];
  cityId: Scalars['ID'];
  displayOrder?: Maybe<Scalars['Int']>;
  headerUrl?: Maybe<Scalars['String']>;
  heyatStatus: HeyatStatus;
  highQualityBroadcast: Scalars['Boolean'];
  id: Scalars['ID'];
  indicator: Scalars['Boolean'];
  isQuran: Scalars['Boolean'];
  isSystem: Scalars['Boolean'];
  languageId: Scalars['ID'];
  liveManagerUserId?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  managerFullName?: Maybe<Scalars['String']>;
  managerNationalCode?: Maybe<Scalars['String']>;
  managerPhoneNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  publishInHomePage?: Maybe<Scalars['Boolean']>;
  published: Scalars['Boolean'];
  registrationNumber?: Maybe<Scalars['String']>;
  singerId?: Maybe<Scalars['ID']>;
  slug?: Maybe<Scalars['String']>;
  speakerId?: Maybe<Scalars['ID']>;
  stateId: Scalars['ID'];
};

export type Output_HeyatUserDto = {
  __typename?: 'Output_HeyatUserDto';
  fullName?: Maybe<Scalars['String']>;
  heyatId?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['String']>;
  nationalCode?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type Output_HeyatVideoDeleteDto = {
  __typename?: 'Output_HeyatVideoDeleteDto';
  id: Scalars['ID'];
};

export type Output_HeyatVideoDto = {
  __typename?: 'Output_HeyatVideoDto';
  code?: Maybe<Scalars['Long']>;
  coverUrl?: Maybe<Scalars['String']>;
  dateTime?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  featured?: Maybe<Scalars['Boolean']>;
  galleryStatus?: Maybe<GalleryStatus>;
  heyatId?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  occasionId?: Maybe<Scalars['ID']>;
  publishInHomePage?: Maybe<Scalars['Boolean']>;
  published: Scalars['Boolean'];
  singerId?: Maybe<Scalars['ID']>;
  speakerId?: Maybe<Scalars['ID']>;
  tagIds?: Maybe<Array<Scalars['ID']>>;
  title?: Maybe<Scalars['String']>;
  totalDownloadsCount?: Maybe<Scalars['Long']>;
  uniqueDownloadsCount?: Maybe<Scalars['Long']>;
  videoUrl?: Maybe<Scalars['String']>;
};

export type Output_HeyatVideoOccasionDto = {
  __typename?: 'Output_HeyatVideoOccasionDto';
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
};

export type Output_HeyatVideoReadDto = {
  __typename?: 'Output_HeyatVideoReadDto';
  code?: Maybe<Scalars['Long']>;
  coverUrl?: Maybe<Scalars['String']>;
  createdDateTime?: Maybe<Scalars['DateTime']>;
  dateTime?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  downloadUrl?: Maybe<Scalars['String']>;
  featured?: Maybe<Scalars['Boolean']>;
  galleryStatus?: Maybe<GalleryStatus>;
  heyatId: Scalars['ID'];
  id?: Maybe<Scalars['ID']>;
  isArchive?: Maybe<Scalars['Boolean']>;
  occasion?: Maybe<Output_HeyatVideoOccasionDto>;
  playerUrl?: Maybe<Scalars['String']>;
  publishInHomePage?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  singer?: Maybe<Output_SpeakerSingerSelectDto>;
  speaker?: Maybe<Output_SpeakerSingerSelectDto>;
  tags?: Maybe<Array<Maybe<Output_TagDto>>>;
  title?: Maybe<Scalars['String']>;
  totalDownloadsCount?: Maybe<Scalars['Long']>;
  uniqueDownloadsCount?: Maybe<Scalars['Long']>;
  updatedDateTime?: Maybe<Scalars['DateTime']>;
  videoUrl?: Maybe<Scalars['String']>;
  viewsCount?: Maybe<Scalars['Long']>;
};

export type Output_HomeAdvertisementDto = {
  __typename?: 'Output_HomeAdvertisementDto';
  advertisementType?: Maybe<AdvertisementType>;
  column: Scalars['Int'];
  imageUrl?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  row: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
};

export type Output_HomeAlbumItemDto = {
  __typename?: 'Output_HomeAlbumItemDto';
  code?: Maybe<Scalars['Long']>;
  coverUrl?: Maybe<Scalars['String']>;
  dateTime: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  heyatName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  images?: Maybe<Array<Maybe<Scalars['String']>>>;
  likesCount: Scalars['Long'];
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type Output_HomeChosenSpeakerSingerDto = {
  __typename?: 'Output_HomeChosenSpeakerSingerDto';
  avatarUrl?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Long']>;
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  slug?: Maybe<Scalars['String']>;
  speakerSingerType?: Maybe<SpeakerSingerType>;
};

export type Output_HomeFaqDto = {
  __typename?: 'Output_HomeFAQDto';
  answer?: Maybe<Scalars['String']>;
  mobile?: Maybe<Scalars['Boolean']>;
  question?: Maybe<Scalars['String']>;
};

export type Output_HomeHaramDto = {
  __typename?: 'Output_HomeHaramDto';
  broadcastLink?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Long']>;
  coverUrl?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  haramsPage?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  likesCount?: Maybe<Scalars['Long']>;
  slug?: Maybe<Scalars['String']>;
  slugName?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  viewsCount?: Maybe<Scalars['Long']>;
};

export type Output_HomeHeyatDetailResDto = {
  __typename?: 'Output_HomeHeyatDetailResDto';
  bannerUrl?: Maybe<Scalars['String']>;
  beta: Scalars['Boolean'];
  code: Scalars['Long'];
  description?: Maybe<Scalars['String']>;
  headerUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isQuran: Scalars['Boolean'];
  likesCount?: Maybe<Scalars['Long']>;
  live: Scalars['Boolean'];
  liveBeta: Scalars['Boolean'];
  liveBroadCastStartTime?: Maybe<Scalars['DateTime']>;
  liveManagerUserId?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  playerLink?: Maybe<Scalars['String']>;
  singer?: Maybe<Output_HomeHeyatSpeakerSingerDto>;
  slug?: Maybe<Scalars['String']>;
  slugName?: Maybe<Scalars['String']>;
  speaker?: Maybe<Output_HomeHeyatSpeakerSingerDto>;
  title?: Maybe<Scalars['String']>;
  viewsCount?: Maybe<Scalars['Long']>;
};

export type Output_HomeHeyatSpeakerSingerDto = {
  __typename?: 'Output_HomeHeyatSpeakerSingerDto';
  avatarUrl?: Maybe<Scalars['String']>;
  code: Scalars['Long'];
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  slug?: Maybe<Scalars['String']>;
  speakerSingerType: SpeakerSingerType;
};

export type Output_HomeHeyatsForSearchVideoResDto = {
  __typename?: 'Output_HomeHeyatsForSearchVideoResDto';
  code: Scalars['Long'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  slugName?: Maybe<Scalars['String']>;
};

export type Output_HomeIndicatorHeyatDto = {
  __typename?: 'Output_HomeIndicatorHeyatDto';
  bannerUrl?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Long']>;
  id?: Maybe<Scalars['ID']>;
  isQuran?: Maybe<Scalars['Boolean']>;
  live?: Maybe<Scalars['Boolean']>;
  liveBroadCastStartTime?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  slugName?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  viewsCount?: Maybe<Scalars['Long']>;
};

export type Output_HomeNewsCategoryDto = {
  __typename?: 'Output_HomeNewsCategoryDto';
  code: Scalars['Long'];
  displayOrder: Scalars['Int'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

export type Output_HomeNewsPageResDto = {
  __typename?: 'Output_HomeNewsPageResDto';
  briefHistory?: Maybe<Scalars['String']>;
  code: Scalars['Long'];
  createdDateTime: Scalars['DateTime'];
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  newsContentCategory?: Maybe<Output_HomeNewsCategoryDto>;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type Output_HomeNewsResDto = {
  __typename?: 'Output_HomeNewsResDto';
  briefHistory?: Maybe<Scalars['String']>;
  code: Scalars['Long'];
  createdDateTime: Scalars['DateTime'];
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type Output_HomeOccasionDto = {
  __typename?: 'Output_HomeOccasionDto';
  description?: Maybe<Scalars['String']>;
  eventDateTime?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  occasionType?: Maybe<OccasionType>;
  title?: Maybe<Scalars['String']>;
};

export type Output_HomePageDto = {
  __typename?: 'Output_HomePageDto';
  code?: Maybe<Scalars['Long']>;
  content?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type Output_HomePageSpeakerSingerDto = {
  __typename?: 'Output_HomePageSpeakerSingerDto';
  avatarUrl?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['DateTime']>;
  chosen?: Maybe<Scalars['Boolean']>;
  code?: Maybe<Scalars['Long']>;
  deathDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  fatherName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  originality?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  speakerSingerType?: Maybe<SpeakerSingerType>;
};

export type Output_HomeProgramDto = {
  __typename?: 'Output_HomeProgramDto';
  code?: Maybe<Scalars['Long']>;
  dateTime?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  imageUrl?: Maybe<Scalars['String']>;
  isQuran?: Maybe<Scalars['Boolean']>;
  live?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  slugName?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  viewsCount?: Maybe<Scalars['Long']>;
};

export type Output_HomeProgramSearchResDto = {
  __typename?: 'Output_HomeProgramSearchResDto';
  code?: Maybe<Scalars['Long']>;
  dateTime: Scalars['DateTime'];
  entityType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  isQuran: Scalars['Boolean'];
  live: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  slugName?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  viewsCount?: Maybe<Scalars['Long']>;
};

export type Output_HomeQuranDto = {
  __typename?: 'Output_HomeQuranDto';
  broadcastLink?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Long']>;
  coverUrl?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  likesCount?: Maybe<Scalars['Long']>;
  quransPage?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  viewsCount?: Maybe<Scalars['Long']>;
};

export type Output_HomeRegisterResDto = {
  __typename?: 'Output_HomeRegisterResDto';
  coolDownSeconds: Scalars['Int'];
  isNew: Scalars['Boolean'];
  verificationCode?: Maybe<Scalars['String']>;
};

export type Output_HomeSliderDto = {
  __typename?: 'Output_HomeSliderDto';
  imageUrl?: Maybe<Scalars['String']>;
  playbackLink?: Maybe<Scalars['String']>;
};

export type Output_HomeVideoItemDto = {
  __typename?: 'Output_HomeVideoItemDto';
  code: Scalars['Long'];
  coverUrl?: Maybe<Scalars['String']>;
  dateTime: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  downloadUrl?: Maybe<Scalars['String']>;
  downloadUrls?: Maybe<Array<Maybe<Output_DownloadWithQuality>>>;
  featured: Scalars['Boolean'];
  heyatCode: Scalars['Long'];
  heyatName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  likesCount: Scalars['Long'];
  qualities?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  totalDownloadsCount: Scalars['Long'];
  uniqueDownloadsCount: Scalars['Long'];
  videoUrl?: Maybe<Scalars['String']>;
  viewsCount?: Maybe<Scalars['Long']>;
};

export type Output_HomeViewCountDto = {
  __typename?: 'Output_HomeViewCountDto';
  id?: Maybe<Scalars['ID']>;
  viewsCount?: Maybe<Scalars['Long']>;
};

export type Output_LanguageDto = {
  __typename?: 'Output_LanguageDto';
  flagUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  languageDirection?: Maybe<LanguageDirection>;
  languageTranslations?: Maybe<Array<Maybe<Output_LanguageTranslationDto>>>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

export type Output_LanguageKeyDto = {
  __typename?: 'Output_LanguageKeyDto';
  id?: Maybe<Scalars['ID']>;
  key?: Maybe<Scalars['String']>;
  languageId?: Maybe<Scalars['ID']>;
  type?: Maybe<Scalars['String']>;
};

export type Output_LanguageTranslationDto = {
  __typename?: 'Output_LanguageTranslationDto';
  createdDateTime?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  key?: Maybe<Scalars['String']>;
  languageId?: Maybe<Scalars['ID']>;
  slug?: Maybe<Scalars['String']>;
  type?: Maybe<LanguageResourceType>;
  updatedDateTime?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['String']>;
};

export type Output_LikeEntityDto = {
  __typename?: 'Output_LikeEntityDto';
  entityId: Scalars['ID'];
  identity?: Maybe<Scalars['String']>;
  likeEntityType: LikeEntityType;
  liked?: Maybe<Scalars['Boolean']>;
  likesCount?: Maybe<Scalars['Long']>;
};

export type Output_LiveBroadCastSettingReadResDto = {
  __typename?: 'Output_LiveBroadCastSettingReadResDto';
  description?: Maybe<Scalars['String']>;
  heyatId: Scalars['ID'];
  id: Scalars['ID'];
  is24HStream: Scalars['Boolean'];
  isOnline: Scalars['Boolean'];
  isTestStream: Scalars['Boolean'];
  liveBroadCastStartTime?: Maybe<Scalars['DateTime']>;
  singer?: Maybe<Output_SpeakerSingerSelectDto>;
  speaker?: Maybe<Output_SpeakerSingerSelectDto>;
  streamServerUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  viewsCount: Scalars['Long'];
};

export type Output_LiveBroadCastSettingTokenDto = {
  __typename?: 'Output_LiveBroadCastSettingTokenDto';
  heyatId?: Maybe<Scalars['ID']>;
  token?: Maybe<Scalars['String']>;
};

export type Output_LiveBroadCastSettingUpdateDto = {
  __typename?: 'Output_LiveBroadCastSettingUpdateDto';
  description?: Maybe<Scalars['String']>;
  heyatId?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  is24HStream: Scalars['Boolean'];
  isTestStream: Scalars['Boolean'];
  liveBroadCastStartTime?: Maybe<Scalars['DateTime']>;
  singerId?: Maybe<Scalars['ID']>;
  speakerId?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type Output_NewsContentCategoryCreateDto = {
  __typename?: 'Output_NewsContentCategoryCreateDto';
  description?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  published: Scalars['Boolean'];
};

export type Output_NewsContentCategoryDeleteDto = {
  __typename?: 'Output_NewsContentCategoryDeleteDto';
  id: Scalars['ID'];
};

export type Output_NewsContentCategoryQueryDto = {
  __typename?: 'Output_NewsContentCategoryQueryDto';
  createdDateTime?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  updatedDateTime?: Maybe<Scalars['DateTime']>;
};

export type Output_NewsContentCategoryUpdateDto = {
  __typename?: 'Output_NewsContentCategoryUpdateDto';
  description?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  published: Scalars['Boolean'];
};

export type Output_NewsCreateDto = {
  __typename?: 'Output_NewsCreateDto';
  briefHistory?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  imageUrl?: Maybe<Scalars['String']>;
  newsContentCategoryId: Scalars['ID'];
  ownerFullName?: Maybe<Scalars['String']>;
  published: Scalars['Boolean'];
  tagIds?: Maybe<Array<Scalars['ID']>>;
  title?: Maybe<Scalars['String']>;
  webUrlDisplay?: Maybe<Scalars['String']>;
};

export type Output_NewsDeleteDto = {
  __typename?: 'Output_NewsDeleteDto';
  id: Scalars['ID'];
};

export type Output_NewsDetailResDto = {
  __typename?: 'Output_NewsDetailResDto';
  briefHistory?: Maybe<Scalars['String']>;
  code: Scalars['Long'];
  createdDateTime: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  newsContentCategory?: Maybe<Output_HomeNewsCategoryDto>;
  slug?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Output_CmsTagDto>>>;
  title?: Maybe<Scalars['String']>;
};

export type Output_NewsQueryDto = {
  __typename?: 'Output_NewsQueryDto';
  briefHistory?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Long']>;
  createdDateTime?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  imageUrl?: Maybe<Scalars['String']>;
  newsContentCategory?: Maybe<Output_NewsContentCategoryQueryDto>;
  ownerFullName?: Maybe<Scalars['String']>;
  published: Scalars['Boolean'];
  slug?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Output_CmsTagDto>>>;
  title?: Maybe<Scalars['String']>;
  updatedDateTime?: Maybe<Scalars['DateTime']>;
  webUrlDisplay?: Maybe<Scalars['String']>;
};

export type Output_NewsUpdateDto = {
  __typename?: 'Output_NewsUpdateDto';
  briefHistory?: Maybe<Scalars['String']>;
  createdDateTime?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  imageUrl?: Maybe<Scalars['String']>;
  newsContentCategoryId: Scalars['ID'];
  ownerFullName?: Maybe<Scalars['String']>;
  published: Scalars['Boolean'];
  tagIds?: Maybe<Array<Scalars['ID']>>;
  title?: Maybe<Scalars['String']>;
  updatedDateTime?: Maybe<Scalars['DateTime']>;
  webUrlDisplay?: Maybe<Scalars['String']>;
};

export type Output_NoticeDeleteDto = {
  __typename?: 'Output_NoticeDeleteDto';
  id: Scalars['ID'];
};

export type Output_NoticeDto = {
  __typename?: 'Output_NoticeDto';
  content?: Maybe<Scalars['String']>;
  dateTime?: Maybe<Scalars['DateTime']>;
  heyatId?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  noticeType: NoticeType;
  roleIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  title?: Maybe<Scalars['String']>;
  userPhoneNumbers?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Output_NoticeHeyatDto = {
  __typename?: 'Output_NoticeHeyatDto';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

export type Output_NoticeReadDto = {
  __typename?: 'Output_NoticeReadDto';
  content?: Maybe<Scalars['String']>;
  createdDateTime: Scalars['DateTime'];
  dateTime?: Maybe<Scalars['DateTime']>;
  heyat?: Maybe<Output_NoticeHeyatDto>;
  id: Scalars['ID'];
  noticeType: NoticeType;
  receiver?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Maybe<Output_NoticeRoleDto>>>;
  sent: Scalars['Boolean'];
  title?: Maybe<Scalars['String']>;
  updatedDateTime: Scalars['DateTime'];
  userPhoneNumbers?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Output_NoticeRoleDto = {
  __typename?: 'Output_NoticeRoleDto';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Output_OccasionCreateDto = {
  __typename?: 'Output_OccasionCreateDto';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  notificationText?: Maybe<Scalars['String']>;
  occasionType: OccasionType;
  published: Scalars['Boolean'];
  title?: Maybe<Scalars['String']>;
};

export type Output_OccasionQueryDto = {
  __typename?: 'Output_OccasionQueryDto';
  createdDateTime?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  eventDateTime?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  notificationText?: Maybe<Scalars['String']>;
  occasionType?: Maybe<OccasionType>;
  published?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  updatedDateTime?: Maybe<Scalars['DateTime']>;
};

export type Output_OccasionUpdateDto = {
  __typename?: 'Output_OccasionUpdateDto';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  notificationText?: Maybe<Scalars['String']>;
  occasionType: OccasionType;
  published: Scalars['Boolean'];
  title?: Maybe<Scalars['String']>;
};

export type Output_OccasionsDeleteDto = {
  __typename?: 'Output_OccasionsDeleteDto';
  id: Scalars['ID'];
};

export type Output_PageDeleteDto = {
  __typename?: 'Output_PageDeleteDto';
  id: Scalars['ID'];
};

export type Output_PageDto = {
  __typename?: 'Output_PageDto';
  content?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  imageUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type Output_PageReadDto = {
  __typename?: 'Output_PageReadDto';
  content?: Maybe<Scalars['String']>;
  createdDateTime: Scalars['DateTime'];
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedDateTime: Scalars['DateTime'];
};

export type Output_ProfileDto = {
  __typename?: 'Output_ProfileDto';
  avatarUrl?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['DateTime']>;
  forceChangePassword?: Maybe<Scalars['Boolean']>;
  forceCompleteProfile?: Maybe<Scalars['Boolean']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastLoginDateTime?: Maybe<Scalars['DateTime']>;
  nationalCode?: Maybe<Scalars['String']>;
  oneToLastLoginDateTime?: Maybe<Scalars['DateTime']>;
  phoneNumber?: Maybe<Scalars['String']>;
  roleDtos?: Maybe<Array<Maybe<Output_RoleDto>>>;
  userName?: Maybe<Scalars['String']>;
  userSettings?: Maybe<Output_UserSettings>;
};

export type Output_QuranDeleteDto = {
  __typename?: 'Output_QuranDeleteDto';
  id: Scalars['ID'];
};

export type Output_QuranDto = {
  __typename?: 'Output_QuranDto';
  code?: Maybe<Scalars['Long']>;
  coverUrl?: Maybe<Scalars['String']>;
  createdDateTime?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  hasProxy?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  playbackLink?: Maybe<Scalars['String']>;
  proxyLink?: Maybe<Scalars['String']>;
  publishInHomePage?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedDateTime?: Maybe<Scalars['DateTime']>;
};

export type Output_RegisterUserDto = {
  __typename?: 'Output_RegisterUserDto';
  avatarUrl?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['DateTime']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  nationalCode?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  verificationCode?: Maybe<Scalars['String']>;
};

export type Output_ResetForgotPasswordResDto = {
  __typename?: 'Output_ResetForgotPasswordResDto';
  id: Scalars['ID'];
};

export type Output_ResourceDto = {
  __typename?: 'Output_ResourceDto';
  fileUrl?: Maybe<Scalars['String']>;
  hasChild: Scalars['Boolean'];
  id: Scalars['ID'];
  order: Scalars['Int'];
  parentId?: Maybe<Scalars['ID']>;
  resourceType: ResourceType;
  title?: Maybe<Scalars['String']>;
  uIResourceType: UiResourceType;
  value?: Maybe<Scalars['String']>;
};

export type Output_ResourcePermissionResDto = {
  __typename?: 'Output_ResourcePermissionResDto';
  id: Scalars['ID'];
  permissionAttribute: PermissionAttribute;
  permissionStatus: PermissionStatus;
  resource?: Maybe<Output_ResourceDto>;
};

export type Output_RoleDto = {
  __typename?: 'Output_RoleDto';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  resourceDtos?: Maybe<Array<Maybe<Output_ResourceDto>>>;
  userDtos?: Maybe<Array<Maybe<Output_UserDto>>>;
};

export type Output_ServerCreateDto = {
  __typename?: 'Output_ServerCreateDto';
  coreCpu: Scalars['Int'];
  cpu: Scalars['Int'];
  endWorkDate?: Maybe<Scalars['DateTime']>;
  endWorkShift?: Maybe<Scalars['String']>;
  iP?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  isSpecial: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  published: Scalars['Boolean'];
  ram: Scalars['Int'];
  specialServerCanNotGetOtherFile: Scalars['Boolean'];
  startWorkDate?: Maybe<Scalars['DateTime']>;
  startWorkShift?: Maybe<Scalars['String']>;
};

export type Output_ServerDeleteDto = {
  __typename?: 'Output_ServerDeleteDto';
  id: Scalars['ID'];
};

export type Output_ServerReadDto = {
  __typename?: 'Output_ServerReadDto';
  coreCpu?: Maybe<Scalars['Int']>;
  cpu?: Maybe<Scalars['Int']>;
  createdDateTime?: Maybe<Scalars['DateTime']>;
  endWorkDate?: Maybe<Scalars['DateTime']>;
  endWorkShift?: Maybe<Scalars['String']>;
  iP?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  isSpecial: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  published: Scalars['Boolean'];
  ram?: Maybe<Scalars['Int']>;
  specialServerCanNotGetOtherFile: Scalars['Boolean'];
  startWorkDate?: Maybe<Scalars['DateTime']>;
  startWorkShift?: Maybe<Scalars['String']>;
  updatedDateTime?: Maybe<Scalars['DateTime']>;
};

export type Output_ServerSetting = {
  __typename?: 'Output_ServerSetting';
  capacity: Scalars['Int'];
  useBeta: Scalars['Boolean'];
};

export type Output_ServerUpdateDto = {
  __typename?: 'Output_ServerUpdateDto';
  coreCpu: Scalars['Int'];
  cpu: Scalars['Int'];
  endWorkDate?: Maybe<Scalars['DateTime']>;
  endWorkShift?: Maybe<Scalars['String']>;
  iP?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isSpecial: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  published: Scalars['Boolean'];
  ram: Scalars['Int'];
  specialServerCanNotGetOtherFile: Scalars['Boolean'];
  startWorkDate?: Maybe<Scalars['DateTime']>;
  startWorkShift?: Maybe<Scalars['String']>;
};

export type Output_SettingDto = {
  __typename?: 'Output_SettingDto';
  mobileTheme: ThemeMode;
  webTheme: ThemeMode;
};

export type Output_SimpleViewRange = {
  __typename?: 'Output_SimpleViewRange';
  max: Scalars['Long'];
  min: Scalars['Long'];
  ratio: Scalars['Int'];
};

export type Output_SliderDeleteDto = {
  __typename?: 'Output_SliderDeleteDto';
  id: Scalars['ID'];
};

export type Output_SliderDto = {
  __typename?: 'Output_SliderDto';
  displayOrder?: Maybe<Scalars['Int']>;
  heyatId?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  imageUrl?: Maybe<Scalars['String']>;
  playbackLink?: Maybe<Scalars['String']>;
  publishInHomePage?: Maybe<Scalars['Boolean']>;
  published: Scalars['Boolean'];
  title?: Maybe<Scalars['String']>;
};

export type Output_SliderHeyatDto = {
  __typename?: 'Output_SliderHeyatDto';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

export type Output_SliderReadDto = {
  __typename?: 'Output_SliderReadDto';
  createdDateTime: Scalars['DateTime'];
  displayOrder?: Maybe<Scalars['Int']>;
  heyat?: Maybe<Output_SliderHeyatDto>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  playbackLink?: Maybe<Scalars['String']>;
  publishInHomePage?: Maybe<Scalars['Boolean']>;
  published: Scalars['Boolean'];
  title?: Maybe<Scalars['String']>;
  updatedDateTime: Scalars['DateTime'];
};

export type Output_SpeakerSingerDeleteDto = {
  __typename?: 'Output_SpeakerSingerDeleteDto';
  id: Scalars['ID'];
};

export type Output_SpeakerSingerDto = {
  __typename?: 'Output_SpeakerSingerDto';
  active?: Maybe<Scalars['Boolean']>;
  avatarUrl?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['DateTime']>;
  chosen?: Maybe<Scalars['Boolean']>;
  code?: Maybe<Scalars['Long']>;
  createdDateTime?: Maybe<Scalars['DateTime']>;
  deathDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  fatherName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  heyats?: Maybe<Array<Maybe<Scalars['String']>>>;
  id?: Maybe<Scalars['ID']>;
  originality?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  publishInHomePage?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
  speakerSingerType?: Maybe<SpeakerSingerType>;
  updatedDateTime?: Maybe<Scalars['DateTime']>;
};

export type Output_SpeakerSingerSelectDto = {
  __typename?: 'Output_SpeakerSingerSelectDto';
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

export type Output_StateDto = {
  __typename?: 'Output_StateDto';
  cities?: Maybe<Array<Maybe<Output_CityDto>>>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type Output_StatusDto = {
  __typename?: 'Output_StatusDto';
  id?: Maybe<Scalars['String']>;
  status: Scalars['Boolean'];
};

export type Output_TagDto = {
  __typename?: 'Output_TagDto';
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
};

export type Output_TempDto = {
  __typename?: 'Output_TempDto';
  temp?: Maybe<Scalars['String']>;
};

export type Output_TicketBookmarkDto = {
  __typename?: 'Output_TicketBookmarkDto';
  bookmark: Scalars['Boolean'];
  id: Scalars['ID'];
};

export type Output_TicketCreateByAdminDto = {
  __typename?: 'Output_TicketCreateByAdminDto';
  attachments?: Maybe<Array<Maybe<Scalars['String']>>>;
  description?: Maybe<Scalars['String']>;
  ticketId?: Maybe<Scalars['ID']>;
  ticketMessageId?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type Output_TicketCreateByUserDto = {
  __typename?: 'Output_TicketCreateByUserDto';
  adminRoleId?: Maybe<Scalars['String']>;
  attachments?: Maybe<Array<Maybe<Scalars['String']>>>;
  description?: Maybe<Scalars['String']>;
  ticketId?: Maybe<Scalars['ID']>;
  ticketMessageId?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
};

export type Output_TicketDeleteDto = {
  __typename?: 'Output_TicketDeleteDto';
  id: Scalars['ID'];
};

export type Output_TicketMessageReadResDto = {
  __typename?: 'Output_TicketMessageReadResDto';
  attachments?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdDateTime: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isFromAdmin: Scalars['Boolean'];
  seen: Scalars['Boolean'];
  title?: Maybe<Scalars['String']>;
  updatedDateTime: Scalars['DateTime'];
};

export type Output_TicketMessageUpdateDto = {
  __typename?: 'Output_TicketMessageUpdateDto';
  attachments?: Maybe<Array<Maybe<Scalars['String']>>>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
};

export type Output_TicketOfMessageResDto = {
  __typename?: 'Output_TicketOfMessageResDto';
  admin?: Maybe<Output_UserTicketDto>;
  id: Scalars['ID'];
  ticketMessages?: Maybe<Array<Maybe<Output_TicketMessageReadResDto>>>;
  user?: Maybe<Output_UserTicketDto>;
};

export type Output_TicketReadResDto = {
  __typename?: 'Output_TicketReadResDto';
  bookmarked: Scalars['Boolean'];
  createdDateTime: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  messagesCount: Scalars['Int'];
  receiver?: Maybe<Output_UserTicketDto>;
  sender?: Maybe<Output_UserTicketDto>;
  title?: Maybe<Scalars['String']>;
  unreadCount: Scalars['Int'];
  updatedDateTime: Scalars['DateTime'];
};

export type Output_TicketRoleDto = {
  __typename?: 'Output_TicketRoleDto';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Output_TicketUserDto = {
  __typename?: 'Output_TicketUserDto';
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type Output_TraditionalDeleteDto = {
  __typename?: 'Output_TraditionalDeleteDto';
  id: Scalars['ID'];
};

export type Output_TraditionalEventCreateDto = {
  __typename?: 'Output_TraditionalEventCreateDto';
  eventDateTime?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  occasionId: Scalars['ID'];
};

export type Output_TraditionalEventQueryDto = {
  __typename?: 'Output_TraditionalEventQueryDto';
  createdDateTime?: Maybe<Scalars['DateTime']>;
  eventDateTime?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  occasion?: Maybe<Output_OccasionQueryDto>;
  published?: Maybe<Scalars['Boolean']>;
  updatedDateTime?: Maybe<Scalars['DateTime']>;
};

export type Output_TraditionalEventUpdateDto = {
  __typename?: 'Output_TraditionalEventUpdateDto';
  eventDateTime?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  occasionId: Scalars['ID'];
};

export type Output_UpdateCmsTagDto = {
  __typename?: 'Output_UpdateCmsTagDto';
  id: Scalars['ID'];
  published: Scalars['Boolean'];
  title?: Maybe<Scalars['String']>;
};

export type Output_UpdateHeyatViewCountDto = {
  __typename?: 'Output_UpdateHeyatViewCountDto';
  id?: Maybe<Scalars['ID']>;
  viewsCount?: Maybe<Scalars['Long']>;
};

export type Output_UserDashboardReportDto = {
  __typename?: 'Output_UserDashboardReportDto';
  heyatAdminsCount: Scalars['Long'];
  loggedInHeyatAdminsCount: Scalars['Long'];
  notLoggedInHeyatAdminsCount: Scalars['Long'];
  usersCount: Scalars['Long'];
};

export type Output_UserDto = {
  __typename?: 'Output_UserDto';
  avatarUrl?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['DateTime']>;
  block?: Maybe<Scalars['Boolean']>;
  creationTime?: Maybe<Scalars['DateTime']>;
  filterRoleName?: Maybe<Scalars['String']>;
  forceChangePassword?: Maybe<Scalars['Boolean']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastLoginDateTime?: Maybe<Scalars['DateTime']>;
  lastModificationTime?: Maybe<Scalars['DateTime']>;
  nationalCode?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  roleDtos?: Maybe<Array<Maybe<Output_RoleDto>>>;
  userName?: Maybe<Scalars['String']>;
};

export type Output_UserSettings = {
  __typename?: 'Output_UserSettings';
  darkMode: Scalars['Boolean'];
  languageSlug?: Maybe<Scalars['String']>;
};

export type Output_UserTicketDto = {
  __typename?: 'Output_UserTicketDto';
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type Output_VerificationCodeResDto = {
  __typename?: 'Output_VerificationCodeResDto';
  verificationCode?: Maybe<Scalars['String']>;
};

export type Output_VerificationResDto = {
  __typename?: 'Output_VerificationResDto';
  temp?: Maybe<Scalars['String']>;
};

export type Output_ViewConfigDto = {
  __typename?: 'Output_ViewConfigDto';
  entityCode: Scalars['Long'];
  entityType: ViewerEntityType;
  published: Scalars['Boolean'];
  simpleVisitRange?: Maybe<Output_SimpleViewRange>;
};

export type Output_ViewerJoinDto = {
  __typename?: 'Output_ViewerJoinDto';
  entityCode: Scalars['Long'];
  entityType: ViewerEntityType;
  join: Scalars['Boolean'];
  userIdentifier?: Maybe<Scalars['String']>;
};

export type Output_ViewersCountDto = {
  __typename?: 'Output_ViewersCountDto';
  code: Scalars['Long'];
  count: Scalars['Long'];
};

export type Output_ViolationCategoryDto = {
  __typename?: 'Output_ViolationCategoryDto';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
};

export type Output_ViolationReportCreateDto = {
  __typename?: 'Output_ViolationReportCreateDto';
  description?: Maybe<Scalars['String']>;
  entityId: Scalars['ID'];
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  violationCategoryId: Scalars['ID'];
  violationEntityType: ViolationEntityType;
};

export type Output_ViolationReportDeleteDto = {
  __typename?: 'Output_ViolationReportDeleteDto';
  id: Scalars['ID'];
};

export type Output_ViolationReportReadResDto = {
  __typename?: 'Output_ViolationReportReadResDto';
  createdDateTime: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  entityId: Scalars['ID'];
  entitySlug?: Maybe<Scalars['String']>;
  entityTitle?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  parentEntityId?: Maybe<Scalars['ID']>;
  updatedDateTime: Scalars['DateTime'];
  user?: Maybe<Output_ViolationReportUserDto>;
  violationCategory?: Maybe<Output_ViolationCategoryDto>;
  violationEntityType: ViolationEntityType;
};

export type Output_ViolationReportUpdateDto = {
  __typename?: 'Output_ViolationReportUpdateDto';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  violationCategoryId: Scalars['ID'];
};

export type Output_ViolationReportUserDto = {
  __typename?: 'Output_ViolationReportUserDto';
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type Output_VisitEntityDto = {
  __typename?: 'Output_VisitEntityDto';
  entityId: Scalars['ID'];
  identity?: Maybe<Scalars['String']>;
  viewsCount?: Maybe<Scalars['Long']>;
  visitEntityType: VisitEntityType;
};

export type PageMutations = {
  __typename?: 'PageMutations';
  createPageCommand?: Maybe<Response_PageDto>;
  deletePageCommand?: Maybe<Response_PageDeleteDto>;
  updatePageCommand?: Maybe<Response_PageDto>;
};


export type PageMutationsCreatePageCommandArgs = {
  request?: InputMaybe<InputMutationData_PageDto>;
};


export type PageMutationsDeletePageCommandArgs = {
  request?: InputMaybe<InputMutationData_PageDeleteDto>;
};


export type PageMutationsUpdatePageCommandArgs = {
  request?: InputMaybe<InputMutationData_PageDto>;
};

export type PageQueries = {
  __typename?: 'PageQueries';
  getPageQuery?: Maybe<Response_PageReadDto>;
  homePagesQuery?: Maybe<Response_HomePageDto>;
};


export type PageQueriesGetPageQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_PageReadDto>;
};


export type PageQueriesHomePagesQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_HomePageDto>;
};

export enum PermissionAttribute {
  Hide = 'HIDE',
  None = 'NONE',
  Readonly = 'READONLY'
}

export enum PermissionStatus {
  Allow = 'ALLOW',
  Deny = 'DENY',
  None = 'NONE'
}

export enum ProcessStatus {
  BigFileConfirmed = 'BIG_FILE_CONFIRMED',
  BigFileDetected = 'BIG_FILE_DETECTED',
  BigFileRejected = 'BIG_FILE_REJECTED',
  FailedProcessed = 'FAILED_PROCESSED',
  NotProcessed = 'NOT_PROCESSED',
  PendingForMerge = 'PENDING_FOR_MERGE',
  PendingForStopRecord = 'PENDING_FOR_STOP_RECORD',
  Processing = 'PROCESSING',
  ProcessFormats = 'PROCESS_FORMATS',
  SuccessFullProcessed = 'SUCCESS_FULL_PROCESSED'
}

export enum ProcessStep {
  Step_0 = 'STEP_0',
  Step_1 = 'STEP_1',
  Step_2 = 'STEP_2',
  Step_3 = 'STEP_3',
  Step_4 = 'STEP_4',
  Step_5 = 'STEP_5',
  Step_6 = 'STEP_6'
}

export type Queries = {
  __typename?: 'Queries';
  advertisementQueries?: Maybe<AdvertisementQueries>;
  archiveQueries?: Maybe<ArchiveQueries>;
  blogContentCategoryQueries?: Maybe<BlogContentCategoryQueries>;
  blogQueries?: Maybe<BlogQueries>;
  contactQueries?: Maybe<ContactQueries>;
  dashboardReportQueries?: Maybe<DashboardReportQueries>;
  fAQQueries?: Maybe<FaqQueries>;
  haramQueries?: Maybe<HaramQueries>;
  heyatProgramQueries?: Maybe<HeyatProgramQueries>;
  heyatQueries?: Maybe<HeyatQueries>;
  languageQueries?: Maybe<LanguageQueries>;
  likeQueries?: Maybe<LikeQueries>;
  monitoringQueries?: Maybe<MonitoringQueries>;
  newsContentCategoryQueries?: Maybe<NewsContentCategoryQueries>;
  newsQueries?: Maybe<NewsQueries>;
  noticeQueries?: Maybe<NoticeQueries>;
  occasionQueries?: Maybe<OccasionQueries>;
  pageQueries?: Maybe<PageQueries>;
  quranQueries?: Maybe<QuranQueries>;
  resourceQueries?: Maybe<ResourceQueries>;
  roleQueries?: Maybe<RoleQueries>;
  serverQueries?: Maybe<ServerQueries>;
  serverSettingQueries?: Maybe<ServerSettingQueries>;
  settingQueries?: Maybe<SettingQueries>;
  sliderQueries?: Maybe<SliderQueries>;
  speakerSingerQueries?: Maybe<SpeakerSingerQueries>;
  stateQueries?: Maybe<StateQueries>;
  tagQueries?: Maybe<TagQueries>;
  tempQueries?: Maybe<TempQueries>;
  ticketQueries?: Maybe<TicketQueries>;
  traditionalEventQueries?: Maybe<TraditionalEventQueries>;
  userQueries?: Maybe<UserQueries>;
  violationReportQueries?: Maybe<ViolationReportQueries>;
};

export type QuranMutations = {
  __typename?: 'QuranMutations';
  createQuranCommand?: Maybe<Response_QuranDto>;
  deleteQuranCommand?: Maybe<Response_QuranDeleteDto>;
  updateQuranCommand?: Maybe<Response_QuranDto>;
};


export type QuranMutationsCreateQuranCommandArgs = {
  request?: InputMaybe<InputMutationData_QuranDto>;
};


export type QuranMutationsDeleteQuranCommandArgs = {
  request?: InputMaybe<InputMutationData_QuranDeleteDto>;
};


export type QuranMutationsUpdateQuranCommandArgs = {
  request?: InputMaybe<InputMutationData_QuranDto>;
};

export type QuranQueries = {
  __typename?: 'QuranQueries';
  getQuranQuery?: Maybe<Response_QuranDto>;
  homeQuransQuery?: Maybe<Response_HomeQuranDto>;
};


export type QuranQueriesGetQuranQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_QuranDto>;
};


export type QuranQueriesHomeQuransQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_HomeQuranDto>;
};

export type ResourceQueries = {
  __typename?: 'ResourceQueries';
  permissions?: Maybe<Response_ResourcePermissionResDto>;
};


export type ResourceQueriesPermissionsArgs = {
  filter?: InputMaybe<InputQueryFilter_ResourcePermissionReqDto>;
};

export enum ResourceType {
  Business = 'BUSINESS',
  None = 'NONE',
  Service = 'SERVICE',
  Ui = 'UI'
}

export type ResponseExceptionStatus = {
  __typename?: 'ResponseExceptionStatus';
  exceptionType?: Maybe<ExceptionGraphType>;
  message?: Maybe<Scalars['String']>;
};

export type Response_AdminEntityViewersCountDto = {
  __typename?: 'Response_AdminEntityViewersCountDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_AdminEntityViewersCountDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_AdminGalleryDto = {
  __typename?: 'Response_AdminGalleryDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_AdminGalleryDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_AdvertisementDto = {
  __typename?: 'Response_AdvertisementDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_AdvertisementDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_AdvertisementUpdateDto = {
  __typename?: 'Response_AdvertisementUpdateDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_AdvertisementUpdateDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_ArchiveDeleteDto = {
  __typename?: 'Response_ArchiveDeleteDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_ArchiveDeleteDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_ArchiveProgressReportDto = {
  __typename?: 'Response_ArchiveProgressReportDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_ArchiveProgressReportDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_ArchiveReadDto = {
  __typename?: 'Response_ArchiveReadDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_ArchiveReadDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_ArchiveUpdateDto = {
  __typename?: 'Response_ArchiveUpdateDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_ArchiveUpdateDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_ArchiveViewCountUpdateDto = {
  __typename?: 'Response_ArchiveViewCountUpdateDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_ArchiveViewCountUpdateDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_AuthenticationDto = {
  __typename?: 'Response_AuthenticationDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_AuthenticationDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_AvatarDto = {
  __typename?: 'Response_AvatarDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_AvatarDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_BlockUserDto = {
  __typename?: 'Response_BlockUserDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_BlockUserDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_BlogContentCategoryCreateDto = {
  __typename?: 'Response_BlogContentCategoryCreateDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_BlogContentCategoryCreateDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_BlogContentCategoryDeleteDto = {
  __typename?: 'Response_BlogContentCategoryDeleteDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_BlogContentCategoryDeleteDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_BlogContentCategoryQueryDto = {
  __typename?: 'Response_BlogContentCategoryQueryDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_BlogContentCategoryQueryDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_BlogContentCategoryUpdateDto = {
  __typename?: 'Response_BlogContentCategoryUpdateDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_BlogContentCategoryUpdateDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_BlogCreateDto = {
  __typename?: 'Response_BlogCreateDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_BlogCreateDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_BlogDeleteDto = {
  __typename?: 'Response_BlogDeleteDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_BlogDeleteDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_BlogQueryDto = {
  __typename?: 'Response_BlogQueryDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_BlogQueryDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_BlogUpdateDto = {
  __typename?: 'Response_BlogUpdateDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_BlogUpdateDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_ChangePasswordResDto = {
  __typename?: 'Response_ChangePasswordResDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_ChangePasswordResDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_ChangePhoneNumberResDto = {
  __typename?: 'Response_ChangePhoneNumberResDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_ChangePhoneNumberResDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_CheckEncoderDto = {
  __typename?: 'Response_CheckEncoderDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_CheckEncoderDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_CheckStatusDto = {
  __typename?: 'Response_CheckStatusDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_CheckStatusDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_CityDto = {
  __typename?: 'Response_CityDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_CityDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_CmsTagDeleteDto = {
  __typename?: 'Response_CmsTagDeleteDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_CmsTagDeleteDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_CmsTagDto = {
  __typename?: 'Response_CmsTagDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_CmsTagDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_ContactUnAuthorizedUsCreateDto = {
  __typename?: 'Response_ContactUnAuthorizedUsCreateDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_ContactUnAuthorizedUsCreateDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_ContactUsCreateDto = {
  __typename?: 'Response_ContactUsCreateDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_ContactUsCreateDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_ContactUsDeleteDto = {
  __typename?: 'Response_ContactUsDeleteDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_ContactUsDeleteDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_ContactUsReadDto = {
  __typename?: 'Response_ContactUsReadDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_ContactUsReadDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_ContactUsUnitDto = {
  __typename?: 'Response_ContactUsUnitDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_ContactUsUnitDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_ContactUsUpdateDto = {
  __typename?: 'Response_ContactUsUpdateDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_ContactUsUpdateDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_DownloadVideoDto = {
  __typename?: 'Response_DownloadVideoDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_DownloadVideoDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_EntityViewersCountDto = {
  __typename?: 'Response_EntityViewersCountDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_EntityViewersCountDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_FaqDeleteDto = {
  __typename?: 'Response_FAQDeleteDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_FaqDeleteDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_FaqDto = {
  __typename?: 'Response_FAQDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_FaqDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_FaqReadDto = {
  __typename?: 'Response_FAQReadDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_FaqReadDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_FileDeleteDto = {
  __typename?: 'Response_FileDeleteDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_FileDeleteDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_FileResDto = {
  __typename?: 'Response_FileResDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_FileResDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_ForceChangePasswordDto = {
  __typename?: 'Response_ForceChangePasswordDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_ForceChangePasswordDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_GalleryStatusDto = {
  __typename?: 'Response_GalleryStatusDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_GalleryStatusDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_HaramDeleteDto = {
  __typename?: 'Response_HaramDeleteDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_HaramDeleteDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_HaramDto = {
  __typename?: 'Response_HaramDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_HaramDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_HeyatAlbumDeleteDto = {
  __typename?: 'Response_HeyatAlbumDeleteDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_HeyatAlbumDeleteDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_HeyatAlbumDto = {
  __typename?: 'Response_HeyatAlbumDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_HeyatAlbumDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_HeyatCityDto = {
  __typename?: 'Response_HeyatCityDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_HeyatCityDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_HeyatCreateResDto = {
  __typename?: 'Response_HeyatCreateResDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_HeyatCreateResDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_HeyatDashboardReportDto = {
  __typename?: 'Response_HeyatDashboardReportDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_HeyatDashboardReportDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_HeyatDeleteDto = {
  __typename?: 'Response_HeyatDeleteDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_HeyatDeleteDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_HeyatDto = {
  __typename?: 'Response_HeyatDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_HeyatDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_HeyatLanguageDto = {
  __typename?: 'Response_HeyatLanguageDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_HeyatLanguageDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_HeyatLiveProgramDto = {
  __typename?: 'Response_HeyatLiveProgramDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_HeyatLiveProgramDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_HeyatProgramRecorderDto = {
  __typename?: 'Response_HeyatProgramRecorderDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_HeyatProgramRecorderDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_HeyatReadDto = {
  __typename?: 'Response_HeyatReadDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_HeyatReadDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_HeyatStateDto = {
  __typename?: 'Response_HeyatStateDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_HeyatStateDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_HeyatStatusDto = {
  __typename?: 'Response_HeyatStatusDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_HeyatStatusDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_HeyatUpdateDto = {
  __typename?: 'Response_HeyatUpdateDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_HeyatUpdateDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_HeyatUserDto = {
  __typename?: 'Response_HeyatUserDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_HeyatUserDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_HeyatVideoDeleteDto = {
  __typename?: 'Response_HeyatVideoDeleteDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_HeyatVideoDeleteDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_HeyatVideoDto = {
  __typename?: 'Response_HeyatVideoDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_HeyatVideoDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_HeyatVideoOccasionDto = {
  __typename?: 'Response_HeyatVideoOccasionDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_HeyatVideoOccasionDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_HeyatVideoReadDto = {
  __typename?: 'Response_HeyatVideoReadDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_HeyatVideoReadDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_HomeAdvertisementDto = {
  __typename?: 'Response_HomeAdvertisementDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_HomeAdvertisementDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_HomeAlbumItemDto = {
  __typename?: 'Response_HomeAlbumItemDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_HomeAlbumItemDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_HomeChosenSpeakerSingerDto = {
  __typename?: 'Response_HomeChosenSpeakerSingerDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_HomeChosenSpeakerSingerDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_HomeFaqDto = {
  __typename?: 'Response_HomeFAQDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_HomeFaqDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_HomeHaramDto = {
  __typename?: 'Response_HomeHaramDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_HomeHaramDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_HomeHeyatDetailResDto = {
  __typename?: 'Response_HomeHeyatDetailResDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_HomeHeyatDetailResDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_HomeHeyatsForSearchVideoResDto = {
  __typename?: 'Response_HomeHeyatsForSearchVideoResDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_HomeHeyatsForSearchVideoResDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_HomeIndicatorHeyatDto = {
  __typename?: 'Response_HomeIndicatorHeyatDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_HomeIndicatorHeyatDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_HomeNewsCategoryDto = {
  __typename?: 'Response_HomeNewsCategoryDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_HomeNewsCategoryDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_HomeNewsPageResDto = {
  __typename?: 'Response_HomeNewsPageResDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_HomeNewsPageResDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_HomeNewsResDto = {
  __typename?: 'Response_HomeNewsResDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_HomeNewsResDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_HomeOccasionDto = {
  __typename?: 'Response_HomeOccasionDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_HomeOccasionDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_HomePageDto = {
  __typename?: 'Response_HomePageDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_HomePageDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_HomePageSpeakerSingerDto = {
  __typename?: 'Response_HomePageSpeakerSingerDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_HomePageSpeakerSingerDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_HomeProgramDto = {
  __typename?: 'Response_HomeProgramDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_HomeProgramDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_HomeProgramSearchResDto = {
  __typename?: 'Response_HomeProgramSearchResDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_HomeProgramSearchResDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_HomeQuranDto = {
  __typename?: 'Response_HomeQuranDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_HomeQuranDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_HomeRegisterResDto = {
  __typename?: 'Response_HomeRegisterResDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_HomeRegisterResDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_HomeSliderDto = {
  __typename?: 'Response_HomeSliderDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_HomeSliderDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_HomeVideoItemDto = {
  __typename?: 'Response_HomeVideoItemDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_HomeVideoItemDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_HomeViewCountDto = {
  __typename?: 'Response_HomeViewCountDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_HomeViewCountDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_LanguageDto = {
  __typename?: 'Response_LanguageDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_LanguageDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_LanguageKeyDto = {
  __typename?: 'Response_LanguageKeyDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_LanguageKeyDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_LanguageTranslationDto = {
  __typename?: 'Response_LanguageTranslationDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_LanguageTranslationDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_LikeEntityDto = {
  __typename?: 'Response_LikeEntityDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_LikeEntityDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_LiveBroadCastSettingReadResDto = {
  __typename?: 'Response_LiveBroadCastSettingReadResDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_LiveBroadCastSettingReadResDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_LiveBroadCastSettingTokenDto = {
  __typename?: 'Response_LiveBroadCastSettingTokenDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_LiveBroadCastSettingTokenDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_LiveBroadCastSettingUpdateDto = {
  __typename?: 'Response_LiveBroadCastSettingUpdateDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_LiveBroadCastSettingUpdateDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_NewsContentCategoryCreateDto = {
  __typename?: 'Response_NewsContentCategoryCreateDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_NewsContentCategoryCreateDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_NewsContentCategoryDeleteDto = {
  __typename?: 'Response_NewsContentCategoryDeleteDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_NewsContentCategoryDeleteDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_NewsContentCategoryQueryDto = {
  __typename?: 'Response_NewsContentCategoryQueryDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_NewsContentCategoryQueryDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_NewsContentCategoryUpdateDto = {
  __typename?: 'Response_NewsContentCategoryUpdateDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_NewsContentCategoryUpdateDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_NewsCreateDto = {
  __typename?: 'Response_NewsCreateDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_NewsCreateDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_NewsDeleteDto = {
  __typename?: 'Response_NewsDeleteDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_NewsDeleteDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_NewsDetailResDto = {
  __typename?: 'Response_NewsDetailResDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_NewsDetailResDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_NewsQueryDto = {
  __typename?: 'Response_NewsQueryDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_NewsQueryDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_NewsUpdateDto = {
  __typename?: 'Response_NewsUpdateDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_NewsUpdateDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_NoticeDeleteDto = {
  __typename?: 'Response_NoticeDeleteDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_NoticeDeleteDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_NoticeDto = {
  __typename?: 'Response_NoticeDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_NoticeDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_NoticeReadDto = {
  __typename?: 'Response_NoticeReadDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_NoticeReadDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_OccasionCreateDto = {
  __typename?: 'Response_OccasionCreateDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_OccasionCreateDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_OccasionQueryDto = {
  __typename?: 'Response_OccasionQueryDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_OccasionQueryDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_OccasionUpdateDto = {
  __typename?: 'Response_OccasionUpdateDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_OccasionUpdateDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_OccasionsDeleteDto = {
  __typename?: 'Response_OccasionsDeleteDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_OccasionsDeleteDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_PageDeleteDto = {
  __typename?: 'Response_PageDeleteDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_PageDeleteDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_PageDto = {
  __typename?: 'Response_PageDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_PageDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_PageReadDto = {
  __typename?: 'Response_PageReadDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_PageReadDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_ProfileDto = {
  __typename?: 'Response_ProfileDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_ProfileDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_QuranDeleteDto = {
  __typename?: 'Response_QuranDeleteDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_QuranDeleteDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_QuranDto = {
  __typename?: 'Response_QuranDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_QuranDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_RegisterUserDto = {
  __typename?: 'Response_RegisterUserDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_RegisterUserDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_ResetForgotPasswordResDto = {
  __typename?: 'Response_ResetForgotPasswordResDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_ResetForgotPasswordResDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_ResourcePermissionResDto = {
  __typename?: 'Response_ResourcePermissionResDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_ResourcePermissionResDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_RoleDto = {
  __typename?: 'Response_RoleDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_RoleDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_ServerCreateDto = {
  __typename?: 'Response_ServerCreateDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_ServerCreateDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_ServerDeleteDto = {
  __typename?: 'Response_ServerDeleteDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_ServerDeleteDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_ServerReadDto = {
  __typename?: 'Response_ServerReadDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_ServerReadDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_ServerSetting = {
  __typename?: 'Response_ServerSetting';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_ServerSetting>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_ServerUpdateDto = {
  __typename?: 'Response_ServerUpdateDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_ServerUpdateDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_SettingDto = {
  __typename?: 'Response_SettingDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_SettingDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_SliderDeleteDto = {
  __typename?: 'Response_SliderDeleteDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_SliderDeleteDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_SliderDto = {
  __typename?: 'Response_SliderDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_SliderDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_SliderHeyatDto = {
  __typename?: 'Response_SliderHeyatDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_SliderHeyatDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_SliderReadDto = {
  __typename?: 'Response_SliderReadDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_SliderReadDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_SpeakerSingerDeleteDto = {
  __typename?: 'Response_SpeakerSingerDeleteDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_SpeakerSingerDeleteDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_SpeakerSingerDto = {
  __typename?: 'Response_SpeakerSingerDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_SpeakerSingerDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_StateDto = {
  __typename?: 'Response_StateDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_StateDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_TagDto = {
  __typename?: 'Response_TagDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_TagDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_TempDto = {
  __typename?: 'Response_TempDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_TempDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_TicketBookmarkDto = {
  __typename?: 'Response_TicketBookmarkDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_TicketBookmarkDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_TicketCreateByAdminDto = {
  __typename?: 'Response_TicketCreateByAdminDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_TicketCreateByAdminDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_TicketCreateByUserDto = {
  __typename?: 'Response_TicketCreateByUserDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_TicketCreateByUserDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_TicketDeleteDto = {
  __typename?: 'Response_TicketDeleteDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_TicketDeleteDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_TicketMessageUpdateDto = {
  __typename?: 'Response_TicketMessageUpdateDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_TicketMessageUpdateDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_TicketOfMessageResDto = {
  __typename?: 'Response_TicketOfMessageResDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_TicketOfMessageResDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_TicketReadResDto = {
  __typename?: 'Response_TicketReadResDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_TicketReadResDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_TicketRoleDto = {
  __typename?: 'Response_TicketRoleDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_TicketRoleDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_TicketUserDto = {
  __typename?: 'Response_TicketUserDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_TicketUserDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_TraditionalDeleteDto = {
  __typename?: 'Response_TraditionalDeleteDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_TraditionalDeleteDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_TraditionalEventCreateDto = {
  __typename?: 'Response_TraditionalEventCreateDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_TraditionalEventCreateDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_TraditionalEventQueryDto = {
  __typename?: 'Response_TraditionalEventQueryDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_TraditionalEventQueryDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_TraditionalEventUpdateDto = {
  __typename?: 'Response_TraditionalEventUpdateDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_TraditionalEventUpdateDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_UpdateCmsTagDto = {
  __typename?: 'Response_UpdateCmsTagDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_UpdateCmsTagDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_UpdateHeyatViewCountDto = {
  __typename?: 'Response_UpdateHeyatViewCountDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_UpdateHeyatViewCountDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_UserDashboardReportDto = {
  __typename?: 'Response_UserDashboardReportDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_UserDashboardReportDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_UserDto = {
  __typename?: 'Response_UserDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_UserDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_UserSettings = {
  __typename?: 'Response_UserSettings';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_UserSettings>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_VerificationCodeResDto = {
  __typename?: 'Response_VerificationCodeResDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_VerificationCodeResDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_VerificationResDto = {
  __typename?: 'Response_VerificationResDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_VerificationResDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_ViewConfigDto = {
  __typename?: 'Response_ViewConfigDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_ViewConfigDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_ViewerJoinDto = {
  __typename?: 'Response_ViewerJoinDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_ViewerJoinDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_ViolationCategoryDto = {
  __typename?: 'Response_ViolationCategoryDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_ViolationCategoryDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_ViolationReportCreateDto = {
  __typename?: 'Response_ViolationReportCreateDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_ViolationReportCreateDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_ViolationReportDeleteDto = {
  __typename?: 'Response_ViolationReportDeleteDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_ViolationReportDeleteDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_ViolationReportReadResDto = {
  __typename?: 'Response_ViolationReportReadResDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_ViolationReportReadResDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_ViolationReportUpdateDto = {
  __typename?: 'Response_ViolationReportUpdateDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_ViolationReportUpdateDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type Response_VisitEntityDto = {
  __typename?: 'Response_VisitEntityDto';
  isSuccess?: Maybe<Scalars['Boolean']>;
  listDto?: Maybe<List_VisitEntityDto>;
  messagingKey?: Maybe<Scalars['String']>;
  responseExceptionStatus?: Maybe<ResponseExceptionStatus>;
};

export type RoleQueries = {
  __typename?: 'RoleQueries';
  getNoticeRolesQuery?: Maybe<Response_RoleDto>;
  roles?: Maybe<Response_RoleDto>;
};


export type RoleQueriesGetNoticeRolesQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_RoleDto>;
};


export type RoleQueriesRolesArgs = {
  filter?: InputMaybe<InputQueryFilter_RoleDto>;
};

export type ServerMutations = {
  __typename?: 'ServerMutations';
  createServerCommand?: Maybe<Response_ServerCreateDto>;
  deleteServerCommand?: Maybe<Response_ServerDeleteDto>;
  updateServerCommand?: Maybe<Response_ServerUpdateDto>;
};


export type ServerMutationsCreateServerCommandArgs = {
  request?: InputMaybe<InputMutationData_ServerCreateDto>;
};


export type ServerMutationsDeleteServerCommandArgs = {
  request?: InputMaybe<InputMutationData_ServerDeleteDto>;
};


export type ServerMutationsUpdateServerCommandArgs = {
  request?: InputMaybe<InputMutationData_ServerUpdateDto>;
};

export type ServerQueries = {
  __typename?: 'ServerQueries';
  archives?: Maybe<Response_ServerReadDto>;
};


export type ServerQueriesArchivesArgs = {
  filter?: InputMaybe<InputQueryFilter_ServerReadDto>;
};

export type ServerSettingMutations = {
  __typename?: 'ServerSettingMutations';
  updateServerSettingsCommand?: Maybe<Response_ServerSetting>;
};


export type ServerSettingMutationsUpdateServerSettingsCommandArgs = {
  request?: InputMaybe<InputMutationData_ServerSetting>;
};

export type ServerSettingQueries = {
  __typename?: 'ServerSettingQueries';
  getServerSettingsQuery?: Maybe<Response_ServerSetting>;
};


export type ServerSettingQueriesGetServerSettingsQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_ServerSetting>;
};

export type SettingMutations = {
  __typename?: 'SettingMutations';
  updateSettingCommand?: Maybe<Response_SettingDto>;
};


export type SettingMutationsUpdateSettingCommandArgs = {
  request?: InputMaybe<InputMutationData_SettingDto>;
};

export type SettingQueries = {
  __typename?: 'SettingQueries';
  getSettingQuery?: Maybe<Response_SettingDto>;
  homeSettingsQuery?: Maybe<Response_SettingDto>;
};


export type SettingQueriesGetSettingQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_SettingDto>;
};


export type SettingQueriesHomeSettingsQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_SettingDto>;
};

export type SliderMutations = {
  __typename?: 'SliderMutations';
  createSliderCommand?: Maybe<Response_SliderDto>;
  deleteSliderCommand?: Maybe<Response_SliderDeleteDto>;
  updateSliderCommand?: Maybe<Response_SliderDto>;
};


export type SliderMutationsCreateSliderCommandArgs = {
  request?: InputMaybe<InputMutationData_SliderDto>;
};


export type SliderMutationsDeleteSliderCommandArgs = {
  request?: InputMaybe<InputMutationData_SliderDeleteDto>;
};


export type SliderMutationsUpdateSliderCommandArgs = {
  request?: InputMaybe<InputMutationData_SliderDto>;
};

export type SliderQueries = {
  __typename?: 'SliderQueries';
  getSliderQuery?: Maybe<Response_SliderReadDto>;
  homeSlidersQuery?: Maybe<Response_HomeSliderDto>;
};


export type SliderQueriesGetSliderQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_SliderReadDto>;
};


export type SliderQueriesHomeSlidersQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_HomeSliderDto>;
};

export type SpeakerSingerMutations = {
  __typename?: 'SpeakerSingerMutations';
  createSpeakerSingerCommand?: Maybe<Response_SpeakerSingerDto>;
  deleteSpeakerSingerCommand?: Maybe<Response_SpeakerSingerDeleteDto>;
  updateSpeakerSingerCommand?: Maybe<Response_SpeakerSingerDto>;
};


export type SpeakerSingerMutationsCreateSpeakerSingerCommandArgs = {
  request?: InputMaybe<InputMutationData_SpeakerSingerDto>;
};


export type SpeakerSingerMutationsDeleteSpeakerSingerCommandArgs = {
  request?: InputMaybe<InputMutationData_SpeakerSingerDeleteDto>;
};


export type SpeakerSingerMutationsUpdateSpeakerSingerCommandArgs = {
  request?: InputMaybe<InputMutationData_SpeakerSingerDto>;
};

export type SpeakerSingerQueries = {
  __typename?: 'SpeakerSingerQueries';
  getSpeakerSingersQuery?: Maybe<Response_SpeakerSingerDto>;
  homeChosenSpeakerSingersQuery?: Maybe<Response_HomeChosenSpeakerSingerDto>;
  homePageSpeakerSingersQuery?: Maybe<Response_HomePageSpeakerSingerDto>;
};


export type SpeakerSingerQueriesGetSpeakerSingersQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_SpeakerSingerDto>;
};


export type SpeakerSingerQueriesHomeChosenSpeakerSingersQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_HomeChosenSpeakerSingerDto>;
};


export type SpeakerSingerQueriesHomePageSpeakerSingersQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_HomePageSpeakerSingerDto>;
};

export enum SpeakerSingerType {
  Both = 'BOTH',
  Singer = 'SINGER',
  Speaker = 'SPEAKER'
}

export type StateQueries = {
  __typename?: 'StateQueries';
  cities?: Maybe<Response_CityDto>;
  heyatCities?: Maybe<Response_HeyatCityDto>;
  heyatStates?: Maybe<Response_HeyatStateDto>;
  states?: Maybe<Response_StateDto>;
};


export type StateQueriesCitiesArgs = {
  filter?: InputMaybe<InputQueryFilter_CityDto>;
};


export type StateQueriesHeyatCitiesArgs = {
  filter?: InputMaybe<InputQueryFilter_HeyatCityDto>;
};


export type StateQueriesHeyatStatesArgs = {
  filter?: InputMaybe<InputQueryFilter_HeyatStateDto>;
};


export type StateQueriesStatesArgs = {
  filter?: InputMaybe<InputQueryFilter_StateDto>;
};

export type TagMutations = {
  __typename?: 'TagMutations';
  createCmsTagCommand?: Maybe<Response_CmsTagDto>;
  createTagCommand?: Maybe<Response_TagDto>;
  deleteCmsTagCommand?: Maybe<Response_CmsTagDeleteDto>;
  updateCmsTagCommand?: Maybe<Response_UpdateCmsTagDto>;
};


export type TagMutationsCreateCmsTagCommandArgs = {
  request?: InputMaybe<InputMutationData_CmsTagDto>;
};


export type TagMutationsCreateTagCommandArgs = {
  request?: InputMaybe<InputMutationData_TagDto>;
};


export type TagMutationsDeleteCmsTagCommandArgs = {
  request?: InputMaybe<InputMutationData_CmsTagDeleteDto>;
};


export type TagMutationsUpdateCmsTagCommandArgs = {
  request?: InputMaybe<InputMutationData_UpdateCmsTagDto>;
};

export type TagQueries = {
  __typename?: 'TagQueries';
  getCmsTagsQuery?: Maybe<Response_CmsTagDto>;
  getTagsQuery?: Maybe<Response_TagDto>;
};


export type TagQueriesGetCmsTagsQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_CmsTagDto>;
};


export type TagQueriesGetTagsQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_TagDto>;
};

export type TempQueries = {
  __typename?: 'TempQueries';
  getLiveServerTempQuery?: Maybe<Response_TempDto>;
};


export type TempQueriesGetLiveServerTempQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_TempDto>;
};

export enum ThemeMode {
  Dark = 'DARK',
  Light = 'LIGHT'
}

export type TicketMutations = {
  __typename?: 'TicketMutations';
  bookmarkTicketCommand?: Maybe<Response_TicketBookmarkDto>;
  createTicketByAdminCommand?: Maybe<Response_TicketCreateByAdminDto>;
  createTicketCommand?: Maybe<Response_TicketCreateByUserDto>;
  deleteTicketCommand?: Maybe<Response_TicketDeleteDto>;
  deleteTicketMessageCommand?: Maybe<Response_TicketDeleteDto>;
  updateTicketMessageCommand?: Maybe<Response_TicketMessageUpdateDto>;
};


export type TicketMutationsBookmarkTicketCommandArgs = {
  request?: InputMaybe<InputMutationData_TicketBookmarkDto>;
};


export type TicketMutationsCreateTicketByAdminCommandArgs = {
  request?: InputMaybe<InputMutationData_TicketCreateByAdminDto>;
};


export type TicketMutationsCreateTicketCommandArgs = {
  request?: InputMaybe<InputMutationData_TicketCreateByUserDto>;
};


export type TicketMutationsDeleteTicketCommandArgs = {
  request?: InputMaybe<InputMutationData_TicketDeleteDto>;
};


export type TicketMutationsDeleteTicketMessageCommandArgs = {
  request?: InputMaybe<InputMutationData_TicketDeleteDto>;
};


export type TicketMutationsUpdateTicketMessageCommandArgs = {
  request?: InputMaybe<InputMutationData_TicketMessageUpdateDto>;
};

export type TicketQueries = {
  __typename?: 'TicketQueries';
  getTicketMessagesQuery?: Maybe<Response_TicketOfMessageResDto>;
  getTicketRolesQuery?: Maybe<Response_TicketRoleDto>;
  getTicketUsersQuery?: Maybe<Response_TicketUserDto>;
  getTicketsQuery?: Maybe<Response_TicketReadResDto>;
};


export type TicketQueriesGetTicketMessagesQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_TicketMessageReadReqDto>;
};


export type TicketQueriesGetTicketRolesQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_TicketRoleDto>;
};


export type TicketQueriesGetTicketUsersQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_TicketUserDto>;
};


export type TicketQueriesGetTicketsQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_TicketReadReqDto>;
};

export type TraditionalEventMutations = {
  __typename?: 'TraditionalEventMutations';
  createTraditionalEventCommand?: Maybe<Response_TraditionalEventCreateDto>;
  deleteTraditionalEventCommand?: Maybe<Response_TraditionalDeleteDto>;
  updateTraditionalEventCommand?: Maybe<Response_TraditionalEventUpdateDto>;
};


export type TraditionalEventMutationsCreateTraditionalEventCommandArgs = {
  request?: InputMaybe<InputMutationData_TraditionalEventCreateDto>;
};


export type TraditionalEventMutationsDeleteTraditionalEventCommandArgs = {
  request?: InputMaybe<InputMutationData_TraditionalDeleteDto>;
};


export type TraditionalEventMutationsUpdateTraditionalEventCommandArgs = {
  request?: InputMaybe<InputMutationData_TraditionalEventUpdateDto>;
};

export type TraditionalEventQueries = {
  __typename?: 'TraditionalEventQueries';
  getTraditionalEventQuery?: Maybe<Response_TraditionalEventQueryDto>;
};


export type TraditionalEventQueriesGetTraditionalEventQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_TraditionalEventQueryDto>;
};

export enum UiResourceType {
  CommonMenu = 'COMMON_MENU',
  Control = 'CONTROL',
  None = 'NONE',
  NotificationMenu = 'NOTIFICATION_MENU'
}

export type UserMutations = {
  __typename?: 'UserMutations';
  blockUser?: Maybe<Response_BlockUserDto>;
  changePassword?: Maybe<Response_ChangePasswordResDto>;
  changePhoneNumber?: Maybe<Response_ChangePhoneNumberResDto>;
  createUser?: Maybe<Response_UserDto>;
  deleteUser?: Maybe<Response_UserDto>;
  forceChangePassword?: Maybe<Response_ForceChangePasswordDto>;
  registerHeyatAdmin?: Maybe<Response_RegisterUserDto>;
  registerHomeUser?: Maybe<Response_HomeRegisterResDto>;
  resetForgotPassword?: Maybe<Response_ResetForgotPasswordResDto>;
  sendChangePhoneNumberVerificationCode?: Maybe<Response_VerificationCodeResDto>;
  sendForgotPasswordVerificationCode?: Maybe<Response_VerificationCodeResDto>;
  updateAvatar?: Maybe<Response_AvatarDto>;
  updateProfile?: Maybe<Response_ProfileDto>;
  updateUser?: Maybe<Response_UserDto>;
  updateUserSettings?: Maybe<Response_UserSettings>;
  verifyHeyatAdmin?: Maybe<Response_AuthenticationDto>;
  verifyHomeUser?: Maybe<Response_AuthenticationDto>;
  verifyUser?: Maybe<Response_VerificationResDto>;
  verifyUserForPhoneNumber?: Maybe<Response_VerificationResDto>;
};


export type UserMutationsBlockUserArgs = {
  request?: InputMaybe<InputMutationData_BlockUserDto>;
};


export type UserMutationsChangePasswordArgs = {
  request?: InputMaybe<InputMutationData_ChangePasswordReqDto>;
};


export type UserMutationsChangePhoneNumberArgs = {
  request?: InputMaybe<InputMutationData_ChangePhoneNumberReqDto>;
};


export type UserMutationsCreateUserArgs = {
  request?: InputMaybe<InputMutationData_UserDto>;
};


export type UserMutationsDeleteUserArgs = {
  request?: InputMaybe<InputMutationData_UserDto>;
};


export type UserMutationsForceChangePasswordArgs = {
  request?: InputMaybe<InputMutationData_ForceChangePasswordDto>;
};


export type UserMutationsRegisterHeyatAdminArgs = {
  request?: InputMaybe<InputMutationData_RegisterUserDto>;
};


export type UserMutationsRegisterHomeUserArgs = {
  request?: InputMaybe<InputMutationData_HomeRegisterReqDto>;
};


export type UserMutationsResetForgotPasswordArgs = {
  request?: InputMaybe<InputMutationData_ResetForgotPasswordReqDto>;
};


export type UserMutationsSendChangePhoneNumberVerificationCodeArgs = {
  request?: InputMaybe<InputMutationData_VerificationCodeReqDto>;
};


export type UserMutationsSendForgotPasswordVerificationCodeArgs = {
  request?: InputMaybe<InputMutationData_VerificationCodeReqDto>;
};


export type UserMutationsUpdateAvatarArgs = {
  request?: InputMaybe<InputMutationData_AvatarDto>;
};


export type UserMutationsUpdateProfileArgs = {
  request?: InputMaybe<InputMutationData_ProfileDto>;
};


export type UserMutationsUpdateUserArgs = {
  request?: InputMaybe<InputMutationData_UserDto>;
};


export type UserMutationsUpdateUserSettingsArgs = {
  request?: InputMaybe<InputMutationData_UserSettings>;
};


export type UserMutationsVerifyHeyatAdminArgs = {
  request?: InputMaybe<InputMutationData_VerificationHeyatAdminReqDto>;
};


export type UserMutationsVerifyHomeUserArgs = {
  request?: InputMaybe<InputMutationData_VerificationHomeRegisterDto>;
};


export type UserMutationsVerifyUserArgs = {
  request?: InputMaybe<InputMutationData_VerificationReqDto>;
};


export type UserMutationsVerifyUserForPhoneNumberArgs = {
  request?: InputMaybe<InputMutationData_VerificationReqDto>;
};

export type UserQueries = {
  __typename?: 'UserQueries';
  heyatUsers?: Maybe<Response_HeyatUserDto>;
  profile?: Maybe<Response_ProfileDto>;
  users?: Maybe<Response_UserDto>;
};


export type UserQueriesHeyatUsersArgs = {
  filter?: InputMaybe<InputQueryFilter_HeyatUserDto>;
};


export type UserQueriesProfileArgs = {
  filter?: InputMaybe<InputQueryFilter_ProfileDto>;
};


export type UserQueriesUsersArgs = {
  filter?: InputMaybe<InputQueryFilter_UserDto>;
};

export type ViewMutations = {
  __typename?: 'ViewMutations';
  visitEntityCommand?: Maybe<Response_VisitEntityDto>;
};


export type ViewMutationsVisitEntityCommandArgs = {
  request?: InputMaybe<InputMutationData_VisitEntityDto>;
};

export enum ViewerEntityType {
  Haram = 'HARAM',
  Heyat = 'HEYAT',
  Quran = 'QURAN'
}

export enum ViolationEntityType {
  Archive = 'ARCHIVE',
  Haram = 'HARAM',
  Heyat = 'HEYAT',
  HeyatAlbum = 'HEYAT_ALBUM',
  HeyatVideo = 'HEYAT_VIDEO',
  Quran = 'QURAN'
}

export type ViolationReportMutations = {
  __typename?: 'ViolationReportMutations';
  createViolationReportCommand?: Maybe<Response_ViolationReportCreateDto>;
  deleteViolationReportCommand?: Maybe<Response_ViolationReportDeleteDto>;
  updateViolationReportCommand?: Maybe<Response_ViolationReportUpdateDto>;
};


export type ViolationReportMutationsCreateViolationReportCommandArgs = {
  request?: InputMaybe<InputMutationData_ViolationReportCreateDto>;
};


export type ViolationReportMutationsDeleteViolationReportCommandArgs = {
  request?: InputMaybe<InputMutationData_ViolationReportDeleteDto>;
};


export type ViolationReportMutationsUpdateViolationReportCommandArgs = {
  request?: InputMaybe<InputMutationData_ViolationReportUpdateDto>;
};

export type ViolationReportQueries = {
  __typename?: 'ViolationReportQueries';
  getViolationCategoriesQuery?: Maybe<Response_ViolationCategoryDto>;
  getViolationReportsQuery?: Maybe<Response_ViolationReportReadResDto>;
};


export type ViolationReportQueriesGetViolationCategoriesQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_ViolationCategoryDto>;
};


export type ViolationReportQueriesGetViolationReportsQueryArgs = {
  filter?: InputMaybe<InputQueryFilter_ViolationReportReadReqDto>;
};

export enum VisitEntityType {
  Haram = 'HARAM',
  Heyat = 'HEYAT',
  HeyatAlbum = 'HEYAT_ALBUM',
  HeyatVideo = 'HEYAT_VIDEO',
  Quran = 'QURAN'
}
